<template>
  <div class="rhdetail" @click.self="charremove">
    <h2 class="top-title">
      <span id="card-name">润滑点详情</span>
    </h2>
    <div class="waring-index pot" v-if="!authority">
      <div style="margin-left: 2px" id="unauthText">
        该润滑点未经授权，请向客户管理员获取全权限，以查看指标实时数值和曲线
      </div>
    </div>
    <Card dis-hover style="margin-top: 16px">
      <div class="detailWrap">
        <div class="imgShow">
          <img
            :src="curDetails.imagesFullPath"
            alt=""
            v-if="curDetails.imagesFullPath"
          />
          <img src="@/assets/images/empty.png" v-else />
        </div>
        <div class="detail" ref="detail">
          <div class="u-flex detail" style="padding-left: 0">
            <p class="name">
              <template v-if="curDetails.onLineStatus === 'OFFLINE'">
                <span class="tag normal">●</span>
                <strong>{{ curDetails.name }}</strong>
              </template>
              <template v-else>
                <span class="tag success">●</span>
                <strong>{{ curDetails.name }}</strong>

                <img
                  v-if="+curDetails.alarmStatus === 0"
                  src="@/assets/images/svg/icon-error.svg"
                  alt=""
                />
                <!-- <img v-else-if="+curDetails.alarmStatus === 1" src="@/assets/images/icon-going.png" alt=""> -->
                <img
                  v-else-if="+curDetails.alarmStatus === 2"
                  src="@/assets/images/svg/icon-warning.svg"
                  alt=""
                />
              </template>
            </p>
            <div
              style="margin-left: 8px"
              class="desc u-flex"
              v-if="
                curDetails.oilSiteAccountStatus &&
                curDetails.oilSiteAccountStatus.length > 0
              "
            >
              <div class="img-border">
                <img
                  src="@/assets/images/sbzt.png"
                  style="width: 14px; height: 12.5px"
                />
              </div>
              <div class="tz-line">
                <Tooltip
                  theme="light"
                  :transfer="true"
                  :max-width="250"
                  class="u-flex"
                  :content="accstatustext(curDetails.oilSiteAccountStatus)"
                >
                  <div class="line-1 text">
                    {{ accstatustext(curDetails.oilSiteAccountStatus) }}
                  </div>
                </Tooltip>
              </div>
            </div>
          </div>

          <div class="signs u-flex">
            <div class="u-flex tagWith">
              <template v-for="(label, key) in curDetails.oilSiteLabelList">
                <div
                  ref="myDivs"
                  :style="{
                    display: tagIndex !== -1 && tagIndex < key ? 'none' : '',
                  }"
                  class="sign"
                  :key="label.oilSiteLabelId"
                >
                  {{ label.oilSiteLabelName }}
                </div>
              </template>
              <template v-if="tagbo">
                <div class="sign">...</div>
              </template>
              <!-- <template v-if="curDetails.oilSiteLabelList.lenth>tagIndex">
                 ...
               </template> -->
            </div>

            <Tooltip
              v-if="userRole == 'm0' || userRole == 'm1' || userRole == 'c1'"
              trigger="hover"
              content="编辑润滑点标签"
              theme="light"
            >
              <div
                v-if="
                  curDetails.oilSiteLabelList &&
                  curDetails.oilSiteLabelList.length == 0
                "
                @click="editSign"
                class="rhname"
              >
                +打标签
              </div>
              <!-- v-if="curDetails.oilSiteLabelList.length==0"    -->
              <template v-else>
                <img
                  @click="editSign"
                  src="@/assets/images/icon-edit.png"
                  alt=""
                  class="edit"
                />
              </template>
            </Tooltip>
          </div>
          <template v-if="userRole && userRole.includes('c')">
            <ul class="codes">
              <li>
                <span class="tit">所属设备：</span>
                <span class="name">{{ curDetails.deviceName || "-" }}</span>
              </li>
              <li>
                <span class="tit">油液监测装置：</span>
                <span class="name">
                  {{ curDetails.zhuangzhiName || "-" }}
                </span>
                <!-- <span class="name" v-else>-</span> -->
              </li>
              <li>
                <span class="tit">创建时间：</span>
                <span class="name">{{ curDetails.gmtCreate || "-" }}</span>
              </li>

              <li>
                <span class="tit">润滑油油品：</span>
                <span class="name">{{ curDetails.oilProductName || "-" }}</span>
              </li>
              <li>
                <span class="tit">润滑点编号：</span>
                <span class="name">{{ curDetails.oilSiteIotName || "-" }}</span>
              </li>
              <li>
                <span class="tit">换油周期：</span>
                <span
                  class="name"
                  v-if="curDetails.oilingFatLiquoringPeriod && curDetails.unit"
                  >{{ curDetails.oilingFatLiquoringPeriod || "-" }}
                  {{ curDetails.unit || "-" }}</span
                >
                <span>-</span>
              </li>
              <li>
                <span class="tit">应用类型</span>
                <span class="name">{{ curDetails.application || "-" }}</span>
              </li>
              <li>
                <span class="tit">油箱容量：</span>
                <span class="name">{{ curDetails.volume || "-" }} L</span>
              </li>

              <!-- <li>
              <span class="tit">润滑点类装置：</span>
              <span class="name">{{curDetails.zhuangzhiName || "-"}}</span>
            </li> -->
              <li>
                <span class="tit">备注：</span>
                <span class="name">{{ curDetails.remake || "-" }}</span>
              </li>
            </ul></template
          >
          <template v-else>
            <ul class="codes">
              <li v-if="userRole && !userRole.includes('c')">
                <span class="tit">所属客户：</span>

                <span class="name">{{ curDetails.consumerName || "-" }}</span>
              </li>
              <li>
                <span class="tit">油液监测装置：</span>
                <span class="name">
                  {{ curDetails.zhuangzhiName || "-" }}
                </span>
                <!-- <span class="name" v-else>-</span> -->
              </li>
              <li>
                <span class="tit">所属设备：</span>
                <span class="name">{{ curDetails.deviceName || "-" }}</span>
              </li>
              <li>
                <span class="tit">润滑油油品：</span>
                <span class="name">{{ curDetails.oilProductName || "-" }}</span>
              </li>
              <li>
                <span class="tit">创建时间：</span>
                <span class="name">{{ curDetails.gmtCreate || "-" }}</span>
              </li>
              <li>
                <span class="tit">换油周期：</span>
                <span
                  class="name"
                  v-if="curDetails.oilingFatLiquoringPeriod && curDetails.unit"
                  >{{ curDetails.oilingFatLiquoringPeriod || "-" }}
                  {{ curDetails.unit || "-" }}</span
                >
                <span>-</span>
              </li>
              <li>
                <span class="tit">润滑点编号：</span>
                <span class="name">{{ curDetails.oilSiteIotName || "-" }}</span>
              </li>
              <li>
                <span class="tit">油箱容量：</span>
                <span class="name">{{ curDetails.volume || "-" }} L</span>
              </li>
              <li>
                <span class="tit">应用类型</span>
                <span class="name">{{ curDetails.application || "-" }}</span>
              </li>

              <!-- <li>
              <span class="tit">润滑点类装置：</span>
              <span class="name">{{curDetails.zhuangzhiName || "-"}}</span>
            </li> -->
              <li>
                <span class="tit">备注：</span>
                <span class="name">{{ curDetails.remake || "-" }}</span>
              </li>
            </ul>
          </template>
        </div>
      </div>
    </Card>

    <template
      v-if="curDetails.graphDeviceComponentId !== undefined && authority"
    >
      <div
        v-show="suggestLength > 0"
        class="waring-index pot"
        @click="navtodetail"
        v-if="+curDetails.alarmStatus === 0 || +curDetails.alarmStatus === 2"
      >
        <template>
          <img style="width: 14px; height: 14px" :src="waringicon" />
          <div style="margin-left: 2px">
            发现了{{ suggestLength }}条可能存在的故障，<span>立即查看></span>
          </div>
        </template>
      </div>
    </template>

    <div class="detectionTag" id="detectionTag" dis-hover>
      <h3
        class="title"
        id="card-title"
        v-if="curDetails.oilSiteModelVOList"
        :name="curDetails.oilSiteModelVOList.length"
      >
        监测指标
      </h3>
      <template v-if="authority">
        <ul
          :class="['detections']"
          v-for="(vol, index) in cartlist"
          :key="index"
          :name="cartlist.length"
        >
          <template v-if="vol.length > 0">
            <li
              class="detectionsli"
              :key="index1 + key1"
              v-for="(index1, key1) in vol"
            >
              <Detectioncard
                :userInfo="userInfo"
                :vol="index1"
                :index="key1"
                :curDetails="curDetails"
                @mode="
                  (e) => {
                    yuzhiShow(e);
                  }
                "
              />
            </li>
          </template>
        </ul>
      </template>

      <ul v-else class="detections detections1">
        <template v-for="vol1 in cartlist">
          <li :key="key" v-for="(vol, key) in vol1">
            <div class="nums">
              <div class="num">
                <p class="temp">
                  <span style="padding: 4px 8px; background: #f2f2f2">{{
                    vol.name
                  }}</span>
                </p>
              </div>
            </div>
          </li>
        </template>
      </ul>
      <!-- {'detHidden' : volListShort} -->
      <!-- <ul :class="['detections',]" v-if="authority">
        <template v-for="(vol,index) in cartlist">
          <li :key="index+'1'">
         
          </li>
        </template>
      </ul> -->
      <!-- <ul v-else class="detections">
        <li v-for="(vol,index) in curDetails.oilSiteModelVOList" :key="index">
          <div class="nums">
            <div class="num">
              <p class="temp">
                <span style="padding:4px 8px;background:#f2f2f2">{{vol.name}}</span>
              </p>
            </div>
          </div>
        </li>
      </ul> -->

      <!-- <template v-if="curDetails.warrant === 1 || curDetails.warrant === null">
        <div class="detTags" :class="[volListShort?'':'detTags1']" v-if="curDetails.oilSiteModelVOList && curDetails.oilSiteModelVOList.length > 3">
          <Icon type="ios-arrow-down" v-if="volListShort" @click="volListShort=false" />
          <Icon type="ios-arrow-up" v-else @click="volListShort=true" />
        </div>
      </template> -->
    </div>

    <!-- 阈值配置 -->

    <Modal
      @on-cancel="cancelYuzhi"
      class="yuzhiModal"
      v-model="yuzhiModal"
      width="500px"
      :mask-closable="false"
      class-name="vertical-center-modal"
    >
      <p slot="header">
        报警配置
        <!-- <span style="color: #0070cc;margin-left:10px;cursor: pointer;font-size: 14px;" @click="rest">重置</span> -->
        <template v-if="groupAuthorityString != 'r'">
          <span
            style="
              color: #0070cc;
              margin-left: 10px;
              cursor: pointer;
              font-size: 14px;
            "
            @click="clearYuzhi"
            >删除配置</span
          >
        </template>
      </p>

      <div class="yuzhi">
        <div class="yuzhi-label">报警阈值配置</div>
        <p class="desc">
          您正在对"
          {{ curDetails.consumerName || "-" }} >
          {{ curDetails.deviceName || "-" }} > {{ curDetails.name || "-" }} >
          {{ yuzhiformData.name || "-" }}"进行报警配置
        </p>
        <Form
          v-if="groupAuthorityString != 'r'"
          ref="formValidate"
          label-position="left"
          :label-width="50"
        >
          <!-- <h4 class="yuzhi-title-drawer" style="margin-top:0">报警阈值配置</h4> -->
          <div class="yuzhi-line-drawer"></div>
          <Row :gutter="gutter" class="yuzhi-cank-drawer"> </Row>
          <template
            v-if="
              yuzhiformData.oilSiteIdentifierIcon &&
              yuzhiformData.oilSiteIdentifierIcon.secureLine
            "
          >
            <Row
              :gutter="gutter"
              class="yuzhi-limit-drwaer"
              v-if="
                yuzhiformData.oilSiteIdentifierIcon.secureLine == '上限' ||
                yuzhiformData.oilSiteIdentifierIcon.secureLine == '上下限'
              "
            >
              <Col span="12">
                <div class="drwaer-flex">
                  <Checkbox
                    @on-change="
                      (val) => {
                        changemenu(1, val);
                      }
                    "
                    v-model="check.toptoplinbo"
                  ></Checkbox>
                  <FormItem span="16" :label-width="80" label="告警值(高)">
                    <InputNumber
                      ref="topTopLine"
                      :disabled="!check.toptoplinbo"
                      v-model="yuzhiformData.topTopLine"
                      @on-blur="checkYuzhiVal(4)"
                      @on-change="checkYuzhiVal(4)"
                      placeholder="请输入"
                    />
                  </FormItem>
                </div>
              </Col>
            </Row>
            <Row
              :gutter="gutter"
              v-if="
                yuzhiformData.oilSiteIdentifierIcon.secureLine == '下限' ||
                yuzhiformData.oilSiteIdentifierIcon.secureLine == '上下限'
              "
              class="yuzhi-limit-drwaer"
            >
              <Col span="12">
                <div class="drwaer-flex">
                  <Checkbox
                    @on-change="
                      (val) => {
                        changemenu(4, val);
                      }
                    "
                    v-model="check.bottombottomlinebo"
                  ></Checkbox>
                  <FormItem label="告警值(低)">
                    <InputNumber
                      v-model="yuzhiformData.bottomBottomLine"
                      @on-blur="checkYuzhiVal(1)"
                      @on-change="checkYuzhiVal(1)"
                      ref="bottomBottomLine"
                      :disabled="!check.bottombottomlinebo"
                      placeholder="请输入"
                    />
                  </FormItem>
                </div>
              </Col>
            </Row>
          </template>
          <template>
            <!-- v-model="secureLine" -->

            <template
              v-if="
                yuzhiformData.oilSiteIdentifierIcon &&
                (yuzhiformData.oilSiteIdentifierIcon.thresholdLine == '下限' ||
                  yuzhiformData.oilSiteIdentifierIcon.thresholdLine == '上限' ||
                  yuzhiformData.oilSiteIdentifierIcon.thresholdLine == '上下限')
              "
            >
              <RadioGroup v-model="isAlgorithmname" @on-change="switchChange">
                <Row
                  :gutter="gutter"
                  class="yuzhi-limit-drwaer"
                  style="margin-bottom: 10px"
                >
                  <Col
                    span="12"
                    class="whi-per u-flex"
                    style="display: flex; margin-bottom: 0px"
                  >
                    <Radio
                      :disabled="
                        check.toplinebo == false && check.bottomlinebo == false
                      "
                      style="margin-left: 110px"
                      :value="0"
                      label="手动配置"
                    ></Radio>
                  </Col>
                  <Col span="12" class="whi-per" style="margin-bottom: 0px">
                    <!-- 算法值 -->
                    <Radio
                      :disabled="
                        check.toplinebo == false && check.bottomlinebo == false
                      "
                      style="margin-left: 40px"
                      :value="1"
                      label="算法参考"
                    />
                  </Col>
                </Row>
              </RadioGroup>
            </template>

            <Row :gutter="gutter" class="yuzhi-limit-drwaer">
              <Col
                span="12"
                v-if="
                  yuzhiformData.oilSiteIdentifierIcon &&
                  (yuzhiformData.oilSiteIdentifierIcon.secureLine == '上限' ||
                    yuzhiformData.oilSiteIdentifierIcon.secureLine == '上下限')
                "
              >
                <div class="drwaer-flex">
                  <Checkbox
                    @on-change="
                      (val) => {
                        changemenu(2, val);
                      }
                    "
                    v-model="check.toplinebo"
                  ></Checkbox>

                  <FormItem label=" 注意值(高)">
                    <InputNumber
                      v-model="yuzhiformData.topLine"
                      @on-blur="checkYuzhiVal(3)"
                      @on-change="checkYuzhiVal(3)"
                      ref="topLine"
                      :disabled="
                        !check.toplinebo || isAlgorithmname == '算法参考'
                      "
                      placeholder="请输入"
                    />
                  </FormItem>
                </div>
              </Col>
              <!-- <Col span="7">{{algformData.labReferBottomLine}}</Col> -->
              <!-- <Col span="7">{{thresholdData.upThreshold ||"-"}}</Col> -->
              <Col
                span="7"
                v-if="
                  yuzhiformData.oilSiteIdentifierIcon &&
                  (yuzhiformData.oilSiteIdentifierIcon.thresholdLine ==
                    '上限' ||
                    yuzhiformData.oilSiteIdentifierIcon.thresholdLine ==
                      '上下限')
                "
              >
                {{ comuupThreshold(thresholdData.upThreshold) || "-" }}
              </Col>
            </Row>

            <Row :gutter="gutter" class="yuzhi-limit-drwaer">
              <Col
                span="12"
                v-if="
                  yuzhiformData.oilSiteIdentifierIcon &&
                  (yuzhiformData.oilSiteIdentifierIcon.secureLine == '下限' ||
                    yuzhiformData.oilSiteIdentifierIcon.secureLine == '上下限')
                "
              >
                <div class="drwaer-flex">
                  <Checkbox
                    @on-change="
                      (val) => {
                        changemenu(3, val);
                      }
                    "
                    v-model="check.bottomlinebo"
                  ></Checkbox>

                  <FormItem label="注意值(低)">
                    <InputNumber
                      v-model="yuzhiformData.bottomLine"
                      @on-blur="checkYuzhiVal(2)"
                      @on-change="checkYuzhiVal(2)"
                      ref="bottomLine"
                      :disabled="
                        isAlgorithmname == '算法参考' || !check.bottomlinebo
                      "
                      placeholder="请输入"
                    />
                  </FormItem>
                </div>
              </Col>
              <!-- <Col span="7">{{algformData.labReferBottomBottomLine}}</Col> -->
              <!-- <Col span="7">{{thresholdData.downThreshold ||"-"}}</Col> -->
              <Col
                span="7"
                v-if="
                  yuzhiformData.oilSiteIdentifierIcon &&
                  (yuzhiformData.oilSiteIdentifierIcon.thresholdLine ==
                    '下限' ||
                    yuzhiformData.oilSiteIdentifierIcon.thresholdLine ==
                      '上下限')
                "
                >{{ comuupThreshold(thresholdData.downThreshold) }}</Col
              >
            </Row>
          </template>
          <h4 class="yuzhi-title-drawer">触发报警配置</h4>
          <div class="yuzhi-line-drawer"></div>

          <div class="yuzhi-warning-drawer">
            <RadioGroup v-model="yuzhiformData.bjtype" @on-change="changeType">
              <Radio label="time">
                连续
                <dxslect
                  :options="cityList"
                  :disabled="yuzhiformData.bjtype === 'time' ? false : true"
                  v-model="yuzhiformData.continuousCount"
                />
                次后触发报警
              </Radio>
              <Radio label="all">
                连续
                <InputNumber
                  ret="continuousTime1"
                  :min="1"
                  v-model="yuzhiformData.continuousTime1"
                  :disabled="yuzhiformData.bjtype === 'all' ? false : true"
                  placeholder="请输入"
                />
                分钟内，共
                <InputNumber
                  ret="continuousCount1"
                  :min="1"
                  v-model="yuzhiformData.continuousCount1"
                  :disabled="yuzhiformData.bjtype === 'all' ? false : true"
                  placeholder="请输入"
                />
                次触发报警
              </Radio>
            </RadioGroup>
          </div>
        </Form>
        <Form v-else ref="formValidate" label-position="left" :label-width="50">
          <!-- <h4 class="yuzhi-title-drawer" style="margin-top:0">报警阈值配置</h4> -->
          <div class="yuzhi-line-drawer"></div>
          <Row :gutter="gutter" class="yuzhi-cank-drawer"> </Row>
          <template
            v-if="
              yuzhiformData.oilSiteIdentifierIcon &&
              yuzhiformData.oilSiteIdentifierIcon.secureLine
            "
          >
            <Row
              :gutter="gutter"
              class="yuzhi-limit-drwaer"
              v-if="
                yuzhiformData.oilSiteIdentifierIcon.secureLine == '上限' ||
                yuzhiformData.oilSiteIdentifierIcon.secureLine == '上下限'
              "
            >
              <Col span="12">
                <div class="drwaer-flex">
                  <FormItem span="16" :label-width="80" label="告警值(高)">
                    <InputNumber
                      :disabled="true"
                      v-model="yuzhiformData.topTopLine"
                      @on-blur="checkYuzhiVal(4)"
                      placeholder="请输入"
                    />
                  </FormItem>
                </div>
              </Col>
            </Row>
            <Row
              :gutter="gutter"
              v-if="
                yuzhiformData.oilSiteIdentifierIcon.secureLine == '下限' ||
                yuzhiformData.oilSiteIdentifierIcon.secureLine == '上下限'
              "
              class="yuzhi-limit-drwaer"
            >
              <Col span="12">
                <div class="drwaer-flex">
                  <FormItem label="告警值(低)">
                    <InputNumber
                      v-model="yuzhiformData.bottomBottomLine"
                      :disabled="true"
                      placeholder="请输入"
                    />
                  </FormItem>
                </div>
              </Col>
            </Row>
          </template>
          <template>
            <!-- v-model="secureLine" -->
            <template
              v-if="
                yuzhiformData.oilSiteIdentifierIcon &&
                (yuzhiformData.oilSiteIdentifierIcon.thresholdLine == '下限' ||
                  yuzhiformData.oilSiteIdentifierIcon.thresholdLine == '上限' ||
                  yuzhiformData.oilSiteIdentifierIcon.thresholdLine == '上下限')
              "
            >
              <RadioGroup v-model="isAlgorithmname" @on-change="switchChange">
                <Row
                  :gutter="gutter"
                  class="yuzhi-limit-drwaer"
                  style="margin-bottom: 10px"
                >
                  <Col
                    span="12"
                    class="whi-per u-flex"
                    style="display: flex; margin-bottom: 0px"
                  >
                    <Radio
                      :disabled="true"
                      style="margin-left: 110px"
                      :value="0"
                      label="手动配置"
                    ></Radio>
                  </Col>
                  <Col span="12" class="whi-per" style="margin-bottom: 0px">
                    <!-- 算法值 -->
                    <Radio
                      :disabled="true"
                      style="margin-left: 40px"
                      :value="1"
                      label="算法参考"
                    />
                  </Col>
                </Row>
              </RadioGroup>
            </template>

            <Row :gutter="gutter" class="yuzhi-limit-drwaer">
              <Col
                span="12"
                v-if="
                  yuzhiformData.oilSiteIdentifierIcon &&
                  (yuzhiformData.oilSiteIdentifierIcon.secureLine == '上限' ||
                    yuzhiformData.oilSiteIdentifierIcon.secureLine == '上下限')
                "
              >
                <div class="drwaer-flex">
                  <FormItem label=" 注意值(高)">
                    <InputNumber
                      v-model="yuzhiformData.topLine"
                      @on-blur="checkYuzhiVal(3)"
                      :disabled="true"
                      placeholder="请输入"
                    />
                  </FormItem>
                </div>
              </Col>
              <!-- <Col span="7">{{algformData.labReferBottomLine}}</Col> -->
              <!-- <Col span="7">{{thresholdData.upThreshold ||"-"}}</Col> -->
              <Col
                span="7"
                v-if="
                  yuzhiformData.oilSiteIdentifierIcon &&
                  (yuzhiformData.oilSiteIdentifierIcon.thresholdLine ==
                    '上限' ||
                    yuzhiformData.oilSiteIdentifierIcon.thresholdLine ==
                      '上下限')
                "
              >
                {{ comuupThreshold(thresholdData.upThreshold) || "-" }}
              </Col>
            </Row>

            <Row :gutter="gutter" class="yuzhi-limit-drwaer">
              <Col
                span="12"
                v-if="
                  yuzhiformData.oilSiteIdentifierIcon &&
                  (yuzhiformData.oilSiteIdentifierIcon.secureLine == '下限' ||
                    yuzhiformData.oilSiteIdentifierIcon.secureLine == '上下限')
                "
              >
                <div class="drwaer-flex">
                  <FormItem label="注意值(低)">
                    <InputNumber
                      v-model="yuzhiformData.bottomLine"
                      @on-blur="checkYuzhiVal(2)"
                      :disabled="true"
                      placeholder="请输入"
                    />
                  </FormItem>
                </div>
              </Col>
              <!-- <Col span="7">{{algformData.labReferBottomBottomLine}}</Col> -->
              <!-- <Col span="7">{{thresholdData.downThreshold ||"-"}}</Col> -->
              <Col
                span="7"
                v-if="
                  yuzhiformData.oilSiteIdentifierIcon &&
                  (yuzhiformData.oilSiteIdentifierIcon.thresholdLine ==
                    '下限' ||
                    yuzhiformData.oilSiteIdentifierIcon.thresholdLine ==
                      '上下限')
                "
                >{{ comuupThreshold(thresholdData.downThreshold) }}</Col
              >
            </Row>
          </template>
          <h4 class="yuzhi-title-drawer">触发报警配置</h4>
          <div class="yuzhi-line-drawer"></div>

          <div class="yuzhi-warning-drawer">
            <RadioGroup
              :disabled="true"
              v-model="yuzhiformData.bjtype"
              @on-change="changeType"
            >
              <Radio disabled label="time">
                连续
                <!-- <dxslect
                  :options="cityList"
                  :disabled="yuzhiformData.bjtype === 'time' ? false : true"
                  v-model="yuzhiformData.continuousCount"
                /> -->
                <InputNumber
                  :min="1"
                  v-model="yuzhiformData.continuousCount"
                  :disabled="true"
                  placeholder="请输入"
                />
                次后触发报警
              </Radio>
              <Radio disabled label="all">
                连续
                <InputNumber
                  ref="tagsModal1"
                  :min="1"
                  v-model="yuzhiformData.continuousTime1"
                  :disabled="yuzhiformData.bjtype === 'all' ? false : true"
                  placeholder="请输入"
                />
                分钟内，共
                <InputNumber
                  :min="1"
                  v-model="yuzhiformData.continuousCount1"
                  :disabled="yuzhiformData.bjtype === 'all' ? false : true"
                  placeholder="请输入"
                />
                次触发报警
              </Radio>
            </RadioGroup>
          </div>
        </Form>
        <div class="yuzhi-line-drawer"></div>
        <span
          style="
            color: #0070cc;
            margin-left: 10px;
            cursor: pointer;
            font-size: 14px;
          "
          @click="recordShow(yuzhiformData)"
          >查看报警配置记录</span
        >
      </div>
      <div class="footer" slot="footer">
        <template v-if="groupAuthorityString != 'r'">
          <Button type="primary" @click="submitYuzhi">提交</Button>
          <Button style="margin-left: 8px" @click="cancelYuzhi">取消</Button>
        </template>
        <template v-else>
          <!-- <Button type="primary" @click="cancelYuzhi">确定</Button> -->
        </template>
      </div>
      <div class="rh-model" v-if="timbo" @click="modelmehods"></div>
    </Modal>

    <!-- 关联指标 -->
    <Modal
      class="releModal"
      v-model="releModal"
      width="400px"
      :footer-hide="true"
      class-name="vertical-center-modal"
    >
      <p slot="header">
        {{ curReleName }}关联指标
        <Tooltip
          placement="right"
          trigger="hover"
          theme="light"
          width="600"
          content="关联指标是衡量在一定时间内当前指标与其他指标的关联性，取值范围为-1 ~ 1。越接近1表示正相关性越大，越接近-1表示负相关性越大，越接近0表示关联性越小"
        >
          <img
            src="../../assets/images/wh.png"
            style="width: 12px; height: 12px; position: relative; top: 1px"
            alt=""
          />
        </Tooltip>
      </p>
      <div class="rele">
        <template v-if="points.length">
          <Row
            class="title"
            style="padding: 8px; margin-bottom: 8px; background: #f2f2f2"
          >
            <Col span="12">指标名称</Col>
            <Col span="12">关联度</Col>
          </Row>
          <Row
            v-for="(point, index) in points"
            :key="index"
            style="padding: 8px"
          >
            <Col span="12">{{ point.correlationProp }}</Col>
            <Col span="12">{{ point.correlationFactor }}</Col>
          </Row>
        </template>
        <Spin v-if="releLoading" style="padding: 120px 174px"></Spin>
        <div class="common-nodatas" v-else-if="!points.length">
          暂无关联数据
        </div>
      </div>
    </Modal>

    <!-- 配置记录 -->
    <Modal
      class="recordModal common-drawer newModal common-list"
      v-model="recordModal"
      :title="recordName"
      width="900px"
      class-name="vertical-center-modal"
    >
      <div class="record">
        <p class="desc">
          您正在查看" {{ curDetails.consumerName || "-" }} >
          {{ curDetails.deviceName || "-" }} > {{ curDetails.name || "-" }} >
          {{ recordformData.name || "-" }}"的阈值配置记录
        </p>
        <div class="common-list" v-if="dataLists.length">
          <Table
            :height="recordHeight"
            class="recordTable"
            :columns="dataColumn"
            :data="dataLists"
          ></Table>
        </div>
        <div class="common-nodatas" v-else-if="!dataLists.length">暂无记录</div>
      </div>
      <div class="common-page fr">
        <Page
          show-total
          show-elevator
          :total="qthrefrom.total"
          @on-page-size-change="getListsSize"
          show-sizer
          :current="qthrefrom.current"
          :page-size="qthrefrom.size"
          @on-change="getrecolist1"
        >
        </Page>
      </div>
      <div class="drawer-footer" slot="footer"></div>
    </Modal>

    <TagsModal
      v-if="curDetails.id"
      ref="tagsModal"
      :curDetails="curDetails"
      :curTags="curTags"
      :tagsModalShow.sync="tagsModalShow"
      :getDetails="getDetails"
      @modCurTags="modCurTags"
      @closetagModal="closetagModal"
    >
    </TagsModal>
    <div v-if="curDetails.oilSiteModelVOList">
      <rhdetaiChats
        :authority="curDetails.warrant"
        :oilSiteId="curId"
        :juearr="juearr"
        :iotProductKey="curDetails.iotProductKey"
        :iotDeviceName="curDetails.iotDeviceName"
        :char="char"
        ref="taiChats"
        :oilSiteModelVOList="curDetails.oilSiteModelVOList"
      />
    </div>
    <div v-if="authority" style="margin-top: 32px; min-height: 370px">
      <RhdetalTabs
        :groupAuthorityString="groupAuthorityString"
        :diagnosticReportList="curDetails.diagnosticReportList"
        :getLists="getDetails"
        :graphDeviceComponentId="curDetails.graphDeviceComponentId"
        :char="char"
        :oilSiteModelVOList="curDetails.oilSiteModelVOList"
        :curId="curId"
        :alarmStatus="curDetails.alarmStatus"
        :rhtbIndex="rhtbIndex"
      />
    </div>
  </div>
</template>

<script>
import api from "@/api";
import ls from "store2";
import deepcopy from "deepcopy";
import * as Echarts from "echarts";
import TagsModal from "./components/tags-modal.vue";
import moment from "moment";
import linchart from "@/components/linchart/linchart";
import Base64 from "@/util/encryptlong";
import waringicon from "@/assets/images/redtail-waring-icon.png";
import shezhi from "@/assets/images/shezhifeis.png";
import rhdetaiChats from "./components/rhdetai-chats";
import RhdetalTabs from "./components/rhdetal-tabs";
import Detectioncard from "./components/Detectioncard";
import { accountstatus } from "@/api/pubrequst";
import { getGroupAuthorityString } from "@/api/business/rhdetail";
import {
  oilSiteGetList,
  relatedInfo,
  sockedDel,
  oilSiteDetail,
} from "@/api/business/rhlist";
import {
  getindication,
  alarming,
  getIndicatorInfo,
} from "@/api/default/defaultdetail.js";
import debounce from "@/util/debounce";
import dxslect from "@/components/dx-select/index";
import { mapState } from "vuex";
export default {
  name: "rhDetail",
  components: {
    TagsModal,
    dxslect,
    linchart,
    rhdetaiChats,
    RhdetalTabs,
    Detectioncard,
  },
  data() {
    return {
      qthrefrom: {
        oilSiteThresholdId: undefined,
        current: 1,
        size: 10,
        total: 0,
      },
      timbo: false,
      timernum: 0,
      soikobj: {},
      forobj: {},
      tagbo: false,
      accoption: [],
      shezhi,
      waringicon,
      juearr: [],
      maxtimerarray: [],
      serobj: {
        seriesIndex: 0,
        seriesName: undefined,
      },
      timeObj: {
        stime: "",
        etime: "",
      },
      isShold: false,
      maxwaveindex: null,
      maxwave: false,
      isAlgorithm: 1,
      isAlgorithmname: undefined,
      single: undefined,
      selectpint: -1, //正在拖动
      maxid: 0, //放大图的id
      chartimer: {},
      gutter: 60,
      alarmRecord: 0,
      check: {
        toptoplinbo: false,
        toplinebo: false,
        bottomlinebo: false,
        bottombottomlinebo: false,
      },
      userInfo: JSON.parse(Base64.decode(ls.page("userInfo"))) || {},
      img01: require("@/assets/images/equ04.jpg"),
      userRole: ls.get("userRole"),
      curId: this.$router.history.current.params.id,
      curDetails: {},
      recordName: "",
      alarmTime: "",
      tag: Math.floor(Math.random() * 10 + 1),
      curScreenWidth: document.body.clientWidth || window.screen.width,
      curScreenHeight: window.screen.height,
      chartModal: false,
      yuzhiModal: false,
      yuzhiModalLoading: false,
      releModal: false,
      releLoading: false,
      recordModal: false,
      recordLoading: false,
      recordHeight: 0,
      recordformData: {},
      curReleName: null,
      tagsModalShow: false,
      warningListLoading: false,
      volListShort: true,
      volLists: [],
      volOptions: [],
      vaosetiop: [],
      vaodatazoom: [],
      points: [],
      curTags: [],
      pageInfo: {
        size: 10,
        current: 1,
        total: 10,
      },
      char: {
        oilSiteIotName: undefined,
        oilSiteTypeId: undefined,
      },
      algformData: {}, // 实验室配置数据
      thresholdData: {}, //算法
      yuzhiformData: {
        isAlgorithm: 0,
        bottomBottomLine: 0,
        topLine: 0,
        bottomLine: 0,
      },
      chartTimer: null,
      myChartMax: {},
      maxChartLoading: false,
      curMaxChartParams: {},
      maxVolOptions: {},
      chartForm: {},
      dataOptions: {
        disabledDate(date) {
          return date && date.valueOf() >= new Date();
        },
      },
      //warningLists: [],
      warid: 0,
      dataLists: [],
      yuzhiValFlag: true, //这个不为true 择无法提交
      timrcustom: false, //这个是是否自定义时间
      labeltimer: {
        stime: null,
        etime: null,
      },
      maxchartobj: {},
      suggestLength: 0,
      _timer: 0,
      cityList: [
        {
          label: "1",
          value: "1",
        },
        {
          label: "2",
          value: "2",
        },
        {
          label: "3",
          value: "3",
        },
      ],
      startimer: [], //完整的最后一次的时间
      groupAuthorityString: "",
      dataColumn: [
        {
          title: "上上限、上限、下限、下下限",
          width: 240,
          render: (h, params) => {
            const item = params.row;
            let arrs = [
              h(
                "span",
                {
                  style: {
                    marginRight: "15px",
                  },
                },
                item.topTopLine || "-"
              ),
              h(
                "span",
                {
                  style: {
                    marginRight: "15px",
                  },
                },
                item.topLine || "-"
              ),
              h(
                "span",
                {
                  style: {
                    marginRight: "15px",
                  },
                },
                item.bottomLine || "-"
              ),
              h(
                "span",
                {
                  style: {
                    marginRight: "15px",
                  },
                },
                item.bottomBottomLine || "-"
              ),
            ];
            return h("div", arrs);
          },
        },
        {
          title: "报警触发规则",
          width: 200,
          render: (h, params) => {
            const item = params.row;
            let arrs = [h("span", "-")];
            if (item.alarmType === 0) {
              arrs = [h("span", `连续${item.continuousCount}分钟触发报警`)];
            } else if (item.alarmType === 1) {
              arrs = [h("span", `连续${item.continuousCount}次后触发报警`)];
            } else if (item.alarmType === 2) {
              arrs = [
                h(
                  "span",
                  `连续${item.continuousTimeTime}分钟内，共${item.continuousTimeCount}次触发报警`
                ),
              ];
            }
            return h("div", arrs);
          },
        },
        {
          title: "配置时间",
          key: "gmtModified",
          width: 200,
          render: (h, params) => {
            const item = params.row;
            return h("div", item.gmtModified || "-");
          },
        },
        {
          title: "配置人",
          key: "operatorName",

          render: (h, params) => {
            const item = params.row;
            return h("div", item.operatorName || "-");
          },
        },
      ],
      colManager: [
        {
          title: "报警描述",
          key: "describe",
          width: 500,
          render: (h, params) => {
            const desc = params.row.describe;
            let desc290 = "";
            if (desc && desc.length > 290)
              desc290 = desc.substring(0, 290) + "...";
            else desc290 = desc || "-";
            return h("div", desc290);
          },
        },
        {
          title: "报警开始时间",
          key: "alarmStartTime",
          render: (h, params) => {
            const item = params.row;
            return h("div", item.alarmStartTime || "-");
          },
        },
        {
          title: "报警结束时间",
          key: "alarmEndTime",
          render: (h, params) => {
            const { index } = params;
            const item = params.row;
            let msg = ""; //da
            let alarmStatus = this.curDetails.alarmStatus;
            if (index == 0) {
              //当第一条的时候 如果状态不是正常的状态下  显示- 否则则正常显示
              if (alarmStatus == 0 || alarmStatus == 2) {
                msg = item.alarmEndTime;
              } else {
                msg = item.alarmEndTime;
              }
            } else {
              msg = item.alarmEndTime || "-";
            }

            return h("div", msg || "-");
          },
        },
        {
          title: "报警持续时间",
          key: "alarmDuration",
          width: 140,
          align: "left",
          render: (h, params) => {
            const item = params.row;

            return h(
              "div",
              {
                style: {
                  whiteSpace: "nowrap",
                },
              },
              this.timeChange(item.alarmDuration)
            );
          },
        },
        {
          title: "操作",
          key: "address",
          align: "left",
          className: "action",
          render: (h, params) => {
            const item = params.row;
            return h("div", [
              h(
                "span",
                {
                  props: {
                    size: "small",
                  },
                  style: {
                    color: "#0c479d", //"#e9aa69",
                    cursor: "pointer",
                    // marginRight: "10px"
                  },
                  on: {
                    click: () => {
                      this.nvtodetl(item);
                    },
                  },
                },
                "详情"
              ),
            ]);
          },
        },
      ],
      cartlist: [],
      tagIndex: -1,
      rhtbIndex: 1,
      userRole: ls.get("userRole"),
    };
  },
  watch: {
    isAlgorithmname: {
      handler(value) {
        let e = value == "手动配置" ? false : true;
        this.isAlgorithm = e;
      },
    },
    yuzhiformData: {
      immediate: true,
      deep: true,
      handler(newvalue) {
        const { topTopLine, topLine, bottomLine, bottomBottomLine } = newvalue;

        if (topTopLine) {
          this.check.toptoplinbo = true;
        }

        if (bottomBottomLine) {
          this.check.bottombottomlinebo = true;
        }
      },
    },
  },

  computed: {
    ...mapState({
      sockedlist: (state) => state.pub.sockedlist,
    }),
    authority() {
      let curDetails = this.curDetails;
      let bo = true;
      if (
        curDetails.warrant === 1 ||
        curDetails.warrant === null ||
        curDetails.warrant === undefined
      ) {
        bo = true;
      } else {
        bo = false;
      }

      return bo;
    },
    givalarmFormart() {
      return (vol, index) => {
        const { name, alarmStatus } = vol;
        if (alarmStatus == 1) {
          //普通状态 不用管
          return [];
        }
        let str = [];
        let currentValue = Number(vol.currentValue);
        let topLine = Number(vol.oilSiteThreshold.topLine);
        let topTopLine = Number(vol.oilSiteThreshold.topTopLine);
        let bottomLine = Number(vol.oilSiteThreshold.bottomLine);
        let bottomBottomLine = Number(vol.oilSiteThreshold.bottomBottomLine);
        let maxNum = 0;
        if (index == 0) {
          if (topTopLine < currentValue) {
            str = ["error"];
          }
        } else if (index == 1) {
          if (bottomLine) {
            maxNum = bottomLine;
          } else if (topLine) {
            maxNum = topLine;
          } else if (topTopLine) {
            maxNum = topTopLine;
          } else {
            maxNum = -1;
          }
          if (maxNum == -1) {
            if (bottomBottomLine < currentValue) {
              str = ["error"];
            }
          } else {
            if (bottomBottomLine < currentValue && maxNum > currentValue) {
              str = ["error"];
            }
          }
        } else if (index == 2) {
          if (vol.oilSiteThreshold.isAlgorithmTop == 1) {
            topLine = Number(vol.oilSiteThreshold.upThreshold);
          }
          if (topTopLine) {
            maxNum = topTopLine;
          } else {
            maxNum = -1;
          }
          if (maxNum == -1) {
            if (topLine < currentValue) {
              str = ["warning"];
            }
          } else {
            if (name == "温度") {
            }
            if (topLine < currentValue && maxNum > currentValue) {
              str = ["warning"];
            }
          }

          // if (bottomLine > currentValue && topLine < currentValue) {
          //   str = ['warning']
          // }
        } else if (index == 3) {
          if (vol.oilSiteThreshold.isAlgorithmBottom == 1) {
            bottomLine = Number(vol.oilSiteThreshold.downThreshold);
          }
          if (topLine) {
            maxNum = topLine;
          } else if (topTopLine) {
            maxNum = topTopLine;
          } else {
            maxNum = -1;
          }
          if (maxNum == -1) {
            if (bottomLine < currentValue) {
              str = ["warning"];
            }
          } else {
            if (bottomLine < currentValue && maxNum > currentValue) {
              str = ["warning"];
            }
          }
        }

        return str;
      };
    },
    formatestart() {
      return (timeStart) => {
        let data = moment(Number(timeStart)).format("yyyy-MM-DD HH:mm:ss");
        return data;
      };
    },
    comuupThreshold() {
      return (data) => {
        let type = typeof data;

        if (type == "number") {
          return data;
        } else {
          return "-";
        }
      };
    },
  },
  created() {
    this.$store.dispatch("pub/SET_TITLE", "润滑点详情");
    if (this.userRole.indexOf("c") > -1) {
      this.dataColumn.forEach((item, index) => {
        if (item.title == "配置时间") this.dataColumn.splice(index, 1);
      });
      this.dataColumn.forEach((item, index) => {
        if (item.title == "配置人") this.dataColumn.splice(index, 1);
      });
      this.recordName = "阈值查看";
    }
    if (this.userRole.indexOf("m1") > -1) {
      this.recordName = "配置记录";
    }
    if (this.userRole.indexOf("m0") > -1) {
      this.recordName = "配置记录";
    }
    if (this.userRole.indexOf("c1") > -1) {
      this.recordName = "配置记录";
    }

    this.getDetails();
  },
  mounted() {
    // this.$Loading.finish();
    this.init();
  },
  beforeDestroy() {
    // 清除定时器

    clearInterval(this.chartTimer);
    this.chartTimer = null;
    this.cleartimer();
  },
  methods: {
    modelmehods() {
      this.$Modal.info({
        title: "提示",
        content: "页面编辑超时，请重新打开",
        onOk: () => {
          this.cancelYuzhi();
        },
      });
    },
    handleSelectClick(event) {
      event.stopPropagation();

      // this.$refs.select.$el.click()
    },
    charremove() {
      let taiChats = this.$refs["taiChats"];
      if (taiChats) {
        taiChats.rechartm();
      }
    },
    accstatustext(oilSiteAccountStatus) {
      let text = "";
      let accoption = this.accoption;
      oilSiteAccountStatus.forEach((e) => {
        text = text + accoption[e].describe + " ";
      });
      return text;
    },
    navtodetail() {
      const routeUrl = this.$router.resolve({
        path: `/default/default-detail?curId=${this.curId}&graphDeviceComponentId=${this.curDetails.graphDeviceComponentId}&warid=${this.warid}&url=rhdetail`,
      });

      window.open(routeUrl.href, "_blank");
    },
    handchatlist(list) {
      let list1 = this.$c.deepClone(list);
      let isQjText = "清洁度ISO4406 4/6/14µm";
      let isfiter = "清洁度NAS";
      let isfiterarr = ["nas23", "nas34"];
      let infearr = ["isoch1", "isoch2", "isoch3"];
      let infearr1 = ["isoch4"];
      let index0 = list1.findIndex((e) => e.identifier == "isoch1");
      let index1 = list1.findIndex((e) => e.identifier == "isoch4");
      let isarr = list1.filter((e) => {
        let bo = infearr.includes(e.identifier);
        return bo;
      });
      let isnasarr = list1.filter((e) => {
        return isfiterarr.includes(e.identifier);
      });

      let ios4 = list1.find((e) => e.identifier == "isoch4");
      if (ios4) {
        ios4.name = "清洁度ISO4406 21µm";
      }
      let filarr = list1.filter((e) => {
        let arr1 = [...infearr, ...infearr1, ...isfiterarr];
        return !arr1.includes(e.identifier);
      });

      let iosTextItem = undefined;
      if (isarr.length > 0) {
        iosTextItem = this.$c.deepClone(isarr[0]);
        iosTextItem["name"] = isQjText;
        iosTextItem["currentValue"] = "";
        iosTextItem["teshu"] = true;
        let slen = isarr.length - 1;
        isarr.forEach((isitem, index) => {
          if (index == 0) {
            iosTextItem["currentValue"] =
              iosTextItem["currentValue"] +
              this.methFixedName(isitem.currentValue);
          } else if (index == slen) {
            iosTextItem["currentValue"] =
              iosTextItem["currentValue"] +
              "/" +
              this.methFixedName(isitem.currentValue);
          } else {
            iosTextItem["currentValue"] =
              iosTextItem["currentValue"] +
              "/" +
              this.methFixedName(isitem.currentValue);
          }
        });
      }

      if (isnasarr.length > 0) {
        let dataitem = "";
        if (isnasarr.length == 1) {
          dataitem = isnasarr[0];
        } else {
          let data0 = Number(isnasarr[0].currentValue);
          let data1 = Number(isnasarr[1].currentValue);

          if (data0 >= data1) {
            dataitem = isnasarr[0];
          } else {
            dataitem = isnasarr[1];
          }

          let finindex = list.findIndex(
            (e) => e.identifier == dataitem.identifier
          );

          filarr.splice(finindex, 0, dataitem);
        }
      }
      let letIdex;
      if (iosTextItem) {
        let isoitemindex = list.findIndex(
          (e) => e.identifier == iosTextItem.identifier
        );

        let leftidentifier = list[isoitemindex - 1].identifier;

        letIdex = list1.findIndex((e) => e.identifier == leftidentifier);

        filarr.splice(letIdex + 1, 0, iosTextItem);
      }
      if (ios4) {
        let ios4emindex = list.findIndex(
          (e) => e.identifier == ios4.identifier
        );

        let iosleftidentifier = list[ios4emindex - 1].identifier;
        // let infearr=['isoch1','isoch2','isoch3']
        if (infearr.includes(iosleftidentifier)) {
          filarr.splice(letIdex + 2, 0, ios4);
        } else {
          let ioslefttwoiider = list[iosleftidentifier - 1].identifier;
          let iosleftwoindex = filarr.findIndex(
            (e) => e.identifier == ioslefttwoiider
          );
          filarr.splice(iosleftwoindex, 0, ios4);
        }
        // let iosletIdex=filarr.findIndex((e)=>e.identifier==iosleftidentifier)
      }

      const categories = [1, 2, 3, 4, 5, 6, 7, 8, 9];

      filarr = categories.map((category) => {
        let arr = filarr.filter(
          (obj) => obj.oilSiteIdentifierIcon.line == category
        );

        return arr;
      });

      return filarr;
    },
    methFixedName(num) {
      if (num === null || num == undefined) {
        return "-";
      }
      if (Number(num) == 0) {
        if (num == 0) {
          return Number(num);
        } else {
          return "-";
        }
      }
      let formateNum = 0;
      if (num) formateNum = Number(num).toFixed(2);
      return Number(formateNum);
    },
    getListsSize(size) {
      this.qthrefrom.size = size;
      this.getrecolist1(1);
    },
    douhaosb(index, vol) {
      if (index == 0) {
        oilSiteThreshold;
        const { oilSiteThreshold } = vol;

        if (
          oilSiteThreshold["topTopLine"] ||
          oilSiteThreshold["bottomBottomLine"]
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        const { name } = vol;
        const { oilSiteThreshold } = vol;
        let topLine = oilSiteThreshold.topLine;
        if (oilSiteThreshold.isAlgorithmTop == 1) {
          topLine = oilSiteThreshold.upThreshold;
        }

        if (
          oilSiteThreshold.topTopLine ||
          oilSiteThreshold.bottomBottomLine ||
          topLine
        ) {
          return true;
        } else {
          return false;
        }
      }
    },

    inputFormate(index) {
      let reg = /^(\d+)(.\d{0,2})?$/;
      let yuzhiformData = this.yuzhiformData;
      let str = "";
      if (index == 4) {
        str = "topTopLine";
      } else if (index == 1) {
        str = "bottomBottomLine";
      } else if (index == 3) {
        str = "topLine";
      } else if ((index = 2)) {
        str = "bottomLine";
      }
      if (!reg.test(yuzhiformData[str])) {
        yuzhiformData[str] = (parseInt(yuzhiformData[str] * 100) / 100).toFixed(
          2
        );
      }
    },

    isShildmth(e) {
      if (e == 0) {
        if (this.isShold) {
          this.isShold = false;
          this.setThreshold(false);
        }
      } else {
        if (this.maxwave) {
          this.maxwave = false;
          this.setmaxwave(false);
        }
      }
    },
    getrecolist1(page = 1) {
      if (page) this.qthrefrom.current = page; //分页处理

      api
        .axss("post", "/ocm-oil-site/oil-site-threshold/history/page", {
          ...this.qthrefrom,
        })
        .then((datas) => {
          if (datas.code == "00000") {
            let data = datas.data;
            this.qthrefrom.total = data.total;

            this.recordModal = true;
            this.dataLists = data.records;
          }
        });
    },
    switchChange(estring) {
      if (estring == "手动配置") {
        //是否使用算法
        this.yuzhiformData.isAlgorithmTop = 0;
        this.yuzhiformData.isAlgorithmBottom = 0;
      } else {
        this.yuzhiformData.isAlgorithmTop = 1;
        this.yuzhiformData.isAlgorithmBottom = 1;
      }
    },
    async nvtodetl(item) {
      let curId = this.curId;
      let graphDeviceComponentId = this.curDetails.graphDeviceComponentId;
      ls.set("warningDetail_" + item.id, item);
      const routeUrl = this.$router.resolve({
        path: `/warning/record/${item.id}?oilSiteId=${item.oilSiteId}&curId=${curId}&graphDeviceComponentId=${graphDeviceComponentId}`,
      });

      window.open(routeUrl.href, "_blank");
      // this.$router.push(
      //   `/warning/record/${item.id}?oilSiteId=${item.oilSiteId}&curId=${curId}&graphDeviceComponentId=${graphDeviceComponentId}`
      // );
    },
    remove() {
      this.vaosetiop[0].showLoading();
    },
    cleartimer() {
      clearInterval(this.chartTimer);
      clearInterval(this._timer);
      this.chartTimer = null;
    },
    // 加载诊断记录
    // getSuggestLists(page) {
    //   //if(page) this.pageInfo.current = page //分页处理
    //   const datas = {
    //     oilSiteId: this.curId,
    //     alarmRecordId: this.warid
    //   }

    //   api.axss(
    //     'post',
    //     '/ocm-oil-site/diagnostic-advice/list',
    //     datas
    //   ).then(res => {

    //     if (res.code === '00000') {
    //       this.suggestLength = res.data.length

    //     }

    //   })
    // },
    async init() {
      let item = this.sockedlist.find((e) => e.type == "oil_identifier_alarm");

      this.soikobj = item;
      this.timernum = item.totalTime * (1000 * 60);
      let data = await accountstatus();
      this.accoption = data.data;
      //  this.$store.state.spinShow = false;
      let Seconds;
      this._timer = setInterval(() => {
        let data = new Date();
        Seconds = data.getUTCSeconds();
        let ti = moment(new Date());
        let m = ti.minute();
        let s = ti.second();

        if ((m % 5 == 0) & (s == 0)) {
          let lins = setTimeout(() => {
            clearTimeout(lins);
            this.getDetails();
          }, 1000 * 10);

          this.chartTimer = setInterval(() => {
            this.getDetails();
          }, 1000 * 60 * 5 + 1000 * 10);
          clearInterval(this._timer);
        }
      }, 1000);

      this.timeObj = {
        etime: new Date().getTime(),
        stime: new Date().getTime() - 1000 * 60 * 60 * 24 * +7,
      };

      // this.getSuggestLists()
    },

    changemenu(index, bo) {
      if (bo == false) {
        if (index == 1) {
          this.yuzhiformData.topTopLine = null;
        } else if (index == 2) {
          //  this.yuzhiformData.topLine = null
        } else if (index == 3) {
          //this.yuzhiformData.bottomLine = null
        } else if (index == 4) {
          this.yuzhiformData.bottomBottomLine = null;
        }
      }

      if (index == 2) {
        this.yuzhiformData.isTop = bo ? 1 : 0;
      } else if (index == 3) {
        this.yuzhiformData.isBottom = bo ? 1 : 0;
      }
    },
    timeChange(times) {
      times = times / 1000;

      let d = moment.duration(+times, "seconds");
      return (
        Math.floor(d.asDays()) +
        "天" +
        d.hours() +
        "时" +
        d.minutes() +
        "分" +
        d.seconds() +
        "秒"
      );
      return this.formatSeconds(times / 1000);
    },
    ongetinto(index, vist) {
      if (vist) {
        this.curDetails.oilSiteModelVOList[index].fzbool = true;
      } else {
        this.curDetails.oilSiteModelVOList[index].fzbool = false;
      }
    },

    synchroni(index) {
      //同步
      if (index == 1) {
        this.yuzhiformData.topTopLine =
          this.algformData.labReferTopTopLine == "-"
            ? this.yuzhiformData.topTopLine
            : this.algformData.labReferTopTopLine;
        this.yuzhiformData.topLine =
          this.algformData.labReferTopLine == "-"
            ? this.yuzhiformData.topLine
            : this.algformData.labReferTopLine;
        this.yuzhiformData.bottomLine =
          this.algformData.labReferBottomLine == "-"
            ? this.yuzhiformData.bottomLine
            : this.algformData.labReferBottomLine;
        this.yuzhiformData.bottomBottomLine =
          this.algformData.labReferBottomBottomLine == "-"
            ? this.yuzhiformData.bottomBottomLine
            : this.algformData.labReferBottomBottomLine;
      } else if (index == 2) {
        this.yuzhiformData.topTopLine =
          this.thresholdData.upUpThreshold == "-"
            ? this.yuzhiformData.topTopLine
            : this.thresholdData.upUpThreshold;
        this.yuzhiformData.topLine =
          this.thresholdData.upThreshold == "-"
            ? this.yuzhiformData.topLine
            : this.thresholdData.upThreshold;
        this.yuzhiformData.bottomLine =
          this.thresholdData.downThreshold == "-"
            ? this.yuzhiformData.bottomLine
            : this.thresholdData.downThreshold;
        this.yuzhiformData.bottomBottomLine =
          this.thresholdData.downDownThreshold == "-"
            ? this.yuzhiformData.bottomBottomLine
            : this.thresholdData.downDownThreshold;
      }
    },
    chartJudgeArr(arr) {
      let arr1 = this.$c.deepClone(arr);
      let juearr = [];

      arr1.forEach((item) => {
        const { oilSiteIdentifierIcon } = item;
        const { isShow, secureLine, isMonotonicity } = oilSiteIdentifierIcon;
        let obj = {
          name: "",
          boshow: false,
          isFluctuate: false,
          hide: !this.isyuzhiutil(item),
          isMonotonicity: false,
        };

        obj["name"] = item.name;
        if (isMonotonicity == 1) {
          obj.isMonotonicity = true;
        }
        // if (!!isShow) {}

        if (!!oilSiteIdentifierIcon.secureLine) {
          obj.boshow = true;
        }
        if (!!oilSiteIdentifierIcon.isFluctuate) {
          obj.isFluctuate = true;
        }

        juearr.push(obj);
      });
      this.juearr = juearr;
    },
    isyuzhiutil(vol) {
      const { oilSiteIdentifierIcon } = vol;
      if (
        oilSiteIdentifierIcon.secureLine == "上限" ||
        oilSiteIdentifierIcon.secureLine == "上下限" ||
        oilSiteIdentifierIcon.secureLine == "下限"
      ) {
        return true;
      } else {
        return false;
      }
    },
    getDetails(param = 0) {
      api
        .axss(
          "get",
          "/ocm-oil-site/oil-site/detail",
          {},
          {
            id: this.curId,
          }
        )
        .then(async (res) => {
          if (res.code === "00000") {
            this.rhtbIndex++;

            let datas = res.data;

            if (datas.alarmRecord) {
              this.warid = datas.alarmRecord.id;
            } else {
              this.warid = "";
            }
            datas.oilSiteModelVOList.map((item) => {
              item.fzbool = false;
              return item;
            });
            this.curDetails = datas;

            this.cartlist = this.handchatlist(
              this.curDetails.oilSiteModelVOList
            );

            this.chartJudgeArr(this.curDetails.oilSiteModelVOList);
            ls.set("curDetails", datas);
            if (this.userRole == "m0") {
              let authdata = await getGroupAuthorityString(datas.tenantId);
              this.groupAuthorityString = authdata.data.groupAuthorityString;
            }

            // oilSiteModelVOList
            //循环volLists
            const name = datas.oilSiteIotName;
            const typeId = datas.oilSiteTypeId;
            this.char.oilSiteIotName = datas.oilSiteIotName;
            this.char.oilSiteTypeId = datas.oilSiteTypeId;
            this.volLists = datas.oilSiteModelVOList;

            if (this.alarmRecord) {
              this.alarmRecord = datas.alarmRecord.id;
            }
            this.$store.state.spinShow = false;
            //  let gzdata = await devicedetail(datas.deviceTypeName)
            this.suggetstlengthmeth();
            setTimeout(() => {
              this.tagWithmt();
            }, 500);
          }
        });
    },
    tagWithmt() {
      let detail = this.$refs["detail"];

      let zWith = 0;
      let singsWith = detail.offsetWidth;
      const divs = this.$refs.myDivs;
      if (!divs) return;
      let len = divs.length - 1;
      for (let i = 0; i < len; i++) {
        const divWidth = divs[i].offsetWidth;
        let oldWithd = 0;
        zWith = zWith + divWidth;
        if (len > i) {
          oldWithd = zWith + divs[i + 1].offsetWidth;
        } else {
          oldWithd = singsWith;
        }

        if (zWith < singsWith && oldWithd >= singsWith) {
          if (divWidth > 0) {
            this.tagIndex = i - 1;
          }
        }
      }
      this.$nextTick(() => {
        let arrbo = divs.filter((e) => {
          const styles = window.getComputedStyle(e);
          const displayStyle = styles.getPropertyValue("display");

          return displayStyle == "none" ? true : false;
        });
        if (arrbo.length > 0) {
          this.tagbo = true;
        } else {
          this.tagbo = false;
        }
      });

      //  this.curDetails.oilSiteLabelList.forEach((item,key)=>{
      //   let text=""
      //   let itemWidth=this.$refs['sign0'].offsetWidth

      //   if(zWith<singsWith){
      //     zWith=zWith+itemWidth

      //     this.tagIndex=key
      //   }

      //  })
    },
    async suggetstlengthmeth() {
      let curId = this.curId;
      let data2 = await alarming(curId); //标题
      const { bottom, bottombottom, top, toptop, name, identifier } =
        data2.data;

      let curDetails = this.curDetails;
      let icatorobj = {
        bottomBottomLine: bottombottom,
        bottomLine: bottom,
        deviceName: curDetails.oilSiteIotName,
        indicator: identifier,
        productKey: curDetails.oilSiteTypeId,
        topLine: top,
        topTopLine: toptop,
      };

      let intiondata = await getIndicatorInfo(icatorobj);

      let { data } = await getindication(
        curDetails.graphDeviceComponentId,
        data2.data.identifier,
        intiondata.data == "" ? "no_detected" : intiondata.data
      ); //故障内容
      console.log("data",data)
      this.suggestLength = data.length;
    },
    getChartDatas(index, id, name, typeId, sd, ed, ss = 1) {
      const { startDateTime, endDateTime } = this.gettimer(10, 0);
      //30 0

      let params = {
        identifier: id,
        oilSiteIotName: name,
        oilSiteTypeId: typeId,

        total: 10000,
        startDateTime,
        endDateTime,
      };
      if (this.curDetails.onLineStatus === "OFFLINE") {
        params.startDateTime = undefined;
        params.endDateTime = undefined;
      }
      if (sd) params.startDateTime = sd;
      if (ed) params.endDateTime = ed;

      if (sd || ed) {
        //params.total = 50000
        params.total = undefined;
      } else {
        params.startDateTime = undefined;
        params.endDateTime = undefined;
        params.total = 1140;
      }

      api.axss("post", "/ocm-oil-site/line-plan/list", params).then((res) => {
        if (res.code === "00000") {
          const datas = res.data;
          if (ss == -1) {
            this.maxtimerarray = datas
              .map((e) => {
                return {
                  name: e.timeDate,
                  value: e.value,
                };
              })
              .reverse();
          }

          const { nums, times, arr1 } = this.setcharsdata(datas);

          this.chartimer[index] = {
            strtimer: 4,
            end: 3,
          };
          if (res.data.length > 0) {
            this.startimer[index] = res.data[res.data.length - 1].timeDate;
          }

          this.createCharts(index, nums, times, sd, ss, id, arr1);
        }
      });
    },
    requstcharts(setparams, callback) {
      //重新请求requset
      const { oilSiteIotName, oilSiteTypeId } = this.char;

      let params = {
        oilSiteIotName,
        oilSiteTypeId,
        ...setparams,
      };
      // if (this.curDetails.onLineStatus === 'OFFLINE') {
      //   params.startDateTime = undefined
      //   params.endDateTime = undefined
      // }

      api.axss("post", "/ocm-oil-site/line-plan/list", params).then((res) => {
        if (res.code === "00000") {
          const datas = res.data;
          if (setparams.name && setparams.name == "max") {
            this.maxtimerarray = datas
              .map((e) => {
                return {
                  name: e.timeDate,
                  value: e.value,
                };
              })
              .reverse();
          }
          const { nums, times, arr1 } = this.setcharsdata(datas);

          callback({
            nums,
            times,
            arr1,
          });
        }
      });
    },
    setcharsdata(datas) {
      //需要的俩个参数

      let nums = [];
      let times = [];
      let arr1 = [];
      datas.reverse().forEach((res, index) => {
        const num = res.value;

        if (0 < +num < 1) {
          nums.push(+num.substring(0, 4));
          // arr1.push([res.timeDate.substring(5, 19), +num.substring(0, 4)])
          arr1.push({
            name: res.timeDate.substring(5, 19),
            value: +num.substring(0, 4),
            visualMap: false,
          });
        } else {
          nums.push(+num);
          // arr1.push([res.timeDate.substring(5, 19), +num])
          arr1.push({
            name: res.timeDate.substring(5, 19),
            value: +num,
            visualMap: false,
          });
        }
        times.push(res.timeDate.slice(5, 19));
      });
      return {
        nums,
        times,
        arr1,
      };
    },
    createCharts(index, nums, times, sd, ss = 1, id, arr = []) {
      if (this.selectpint == index) {
        return false;
      }
      var vm = this;
      var myChart;
      if (myChart) myChart.dispose(); //销毁
      let end = 90; //显示比例

      myChart = Echarts.init(document.getElementById(`chart${index}`), "light");

      // 第一次之后,不需要loading
      if (!this.volOptions.length) myChart.showLoading();
      //解决图表左侧空间
      let gLeft = "10%";
      let numsCopy = deepcopy(nums);
      numsCopy = numsCopy.sort(function (a, b) {
        return a - b;
      });
      //end

      if (numsCopy.length < 500) {
        end = 0;
      } else {
        end = (1 - 500 / numsCopy.length) * 100;
      }

      const maxNum = numsCopy[numsCopy.length - 1] || 0;
      const minNum = numsCopy[0] || 0;

      if (maxNum > 999 || maxNum.toString().length > 3) gLeft = "11%";
      if (maxNum > 9999 || maxNum.toString().length > 4) gLeft = "13%";
      if (maxNum > 99999 || maxNum.toString().length > 5) gLeft = "15%";
      if (maxNum > 999999 || maxNum.toString().length > 6) gLeft = "17%";
      if (maxNum > 999999 || maxNum.toString().length > 7) gLeft = "19%";

      setTimeout(() => {
        // 指定图表的配置项和数据
        let linarr = [];
        let oilSiteThreshold = this.volLists[index].oilSiteThreshold;
        // if (oilSiteThreshold) {
        //   if (oilSiteThreshold.topTopLine) {
        //     linarr.push({
        //       lineStyle: {
        //         //警戒线的样式 ，虚实 颜色
        //         type: "dotted", //样式  ‘solid’和'dotted'
        //         color: "#f5222d",
        //         width: 2, //宽度
        //       },
        //       yAxis: oilSiteThreshold.topTopLine,
        //     })
        //   }
        //   if (oilSiteThreshold.topLine) {
        //     linarr.push({
        //       lineStyle: {
        //         //警戒线的样式 ，虚实 颜色
        //         type: "dotted", //样式  ‘solid’和'dotted'
        //         color: "#ff9b04",
        //         width: 2, //宽度
        //       },
        //       yAxis: oilSiteThreshold.topLine,
        //     })

        //   }
        //   if (oilSiteThreshold.bottomBottomLine) {
        //     linarr.push({
        //       lineStyle: {
        //         //警戒线的样式 ，虚实 颜色
        //         type: "dotted", //样式  ‘solid’和'dotted'
        //         color: "#f5222d",
        //         width: 2, //宽度
        //       },
        //       yAxis: oilSiteThreshold.bottomBottomLine
        //     })

        //   }
        //   if (oilSiteThreshold.bottomLine) {
        //     linarr.push({
        //       lineStyle: {
        //         //警戒线的样式 ，虚实 颜色
        //         type: "dotted", //样式  ‘solid’和'dotted'
        //         color: "#ff9b04",
        //         width: 2, //宽度
        //       },
        //       yAxis: oilSiteThreshold.bottomLine,
        //     }, )
        //   }
        // }
        let minbili = 3 / arr.length;
        let option = {
          title: {
            text: "暂无数据",
            show: arr.length > 0 ? false : true,
            left: "center",
            top: "center",
            textStyle: {
              color: "#fff",
              fontSize: "20px",
              fontWeight: 400,
            },
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "line", //横轴会出现虚线
            },
            position: function (pt) {
              position: ["50%", "50%"];
            },
            textStyle: {
              fontSize: 12,
            },
            formatter: (e) => {
              const { seriesIndex, seriesName } = this.serobj;
              let data = e[0];
              if (seriesIndex == 0) {
                data = e[0];
              } else {
                data = e.find((e) => {
                  return e.seriesName == seriesName;
                });
              }

              if (!data || !data.value) {
                data = e[0];
              }

              //let data = e[0]
              // e[0].marker+"<div>111</div>"
              return `
                <div>
                <div>${data.axisValue}</div>
                <div style="display:flex;align-items:center;margin-top:4px">
                 ${data.marker} 
                 <div style="margin-left:4px">${data.seriesName}</div>
                 <div style="margin-left:24px;font-weight: bold;color:#6a6a6a">${data.value.toFixed(
                   2
                 )}</div>
                </div>
                </div>
                `;
            },
          },
          textStyle: {
            fontSize: "12px",
            fontWeight: "normal",
          },
          grid: {
            top: "5%",
            left: gLeft,
            right: "7%",
            bottom: "10%",
          },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: times,
          },
          yAxis: {
            type: "value",
            min: minNum.toFixed(3), //0,
            scale: true,
            // max: function (value) {
            //     return (value.max * 1.2).toFixed(1)
            // }
            axisLine: {
              onZero: false,
            },
          },
          dataZoom: [
            {
              type: "inside",
              start: end,
              end: 100,
              handleSize: "100%",
              minSpan: minbili * 100,
            },
          ],
          color: "#5470c6",
          series: [
            {
              //   tooltip: {
              //  // trigger: "axis",
              //   axisPointer: {
              //     type: "line", //横轴会出现虚线
              //   },
              //   position: function(pt) {
              //     position: ["50%", "50%"];
              //   },
              //   textStyle: {
              //     fontSize: 12,
              //   },

              // },
              name: this.volLists[index].name,
              // data: nums,
              data: arr,
              type: "line",
              stack: "折线图",
              connectNulls: true,
              // symbol: "none",
              smooth: true,
              lineStyle: {
                width: 2,
              },

              markLine: {
                show: false,
                symbol: ["none"], //['none']表示是一条横线；['arrow', 'none']表示线的左边是箭头，右边没右箭头；['none','arrow']表示线的左边没有箭头，右边有箭头
                label: {
                  show: false,
                  position: "middle", //将警示值放在哪个位置，三个值“start”,"middle","end" 开始 中点 结束
                },
                data: linarr,
              },
            },
          ],
        };

        // 动态变量
        // eval("let volOption_" + index + "=" + option)
        if (sd || ss == -1) {
          //大屏

          this.maxVolOptions = option; // max的搜索时间数据
          myChart.hideLoading();
          if (sd || ss == -1) this.toMaxChart(index);
        } else {
          this.volOptions[index] = option;
          this.vaosetiop[index] = myChart;
          this.vaodatazoom[index] = {
            type: "inside",
            start: end,
            end: 100,
            handleSize: "100%",
          };
          myChart.hideLoading();

          // 使用刚指定的配置项和数据显示图表。

          myChart.setOption(option);
          // myChart.on("click", () => {
          //   let option = myChart.getOption()

          // })
          myChart.on("globalout", () => {
            if (index == this.selectpint) {
              this.selectpint = -1;
            }
          });
          //滑动时候触发的事件
          myChart.on("datazoom", (params) => {
            if (!params.batch) {
              return;
            }

            let batch = params.batch[0];

            this.vaodatazoom[index].start = batch.start;
            this.vaodatazoom[index].end = batch.end;
            this.selectpint = index;

            return;
          });
        }
      }, 1000);
    },

    charappend(op, index, id, myChart) {
      let option = JSON.parse(JSON.stringify(op));

      this.chartimer[index].strtimer = this.chartimer[index].strtimer + 1;
      this.chartimer[index].end = this.chartimer[index].end + 1;

      const { startDateTime, endDateTime } = this.gettimer(
        this.chartimer[index].strtimer,
        this.chartimer[index].end
      );

      this.$nextTick(() => {
        this.requstcharts(
          {
            startDateTime,
            endDateTime,
            identifier: id,
            total: 999,
          },
          (data) => {
            if (data.times.length > 0) {
              let arr1 = data.arr1;
              myChart.appendData({
                seriesIndex: 0,
                data: arr1,
              });
              //    myChart.setOption(option)
            }
          }
        );
      });
    },
    gettimer(str, end) {
      //获取时间
      let startDateTime;
      let endDateTime;
      startDateTime = new Date().getTime() - 24 * 60 * 60 * 1000 * str; //昨天和今天的
      if (end == 0) {
        endDateTime = new Date().getTime();
      } else {
        endDateTime = new Date().getTime() - 24 * 60 * 60 * 1000 * end;
      }
      return {
        startDateTime,
        endDateTime,
      };
    },
    datemonth(date1, date2) {
      var day1 = new Date(date1);
      var day2 = new Date(date2);
      var day3 = new Date();
      let chaju = (day2 - day1) / (1000 * 60 * 60 * 24);

      if (chaju > 30) {
        return 1;
      } else {
        return 0;
      }
    },
    changeChartDate(date, tag) {
      if (!date) {
        // this.refs["select"].clearSingleSelect()
        this.chartForm.range = "7";
        let curTime = new Date().getTime();
        let stime = curTime - 1000 * 60 * 60 * 24 * +7;
        this.labeltimer = {
          stime: this.$moment(stime).format("YYYY-MM-DD "),
          etime: this.$moment(stime).add(7, "days").format("YYYY-MM-DD"),
        };
        return;
      }
      if (date == 0 && tag == "range") {
        this.timrcustom = true;
        return;
      } else if (tag == "date" || date == undefined) {
        this.timrcustom = true;
      } else {
        this.timrcustom = false;
      }

      // 时间范围
      // this.chartForm.startDateTime 1= date[0]
      // this.chartForm.endDateTime = date[1]
      // 清空时阻止再次渲染
      if (tag != "range") {
        // this.chartForm.rang = null
        let m = this.datemonth(date[0], date[1]);
        if (m > 0) {
          this.chartForm.date = null;
          this.$Message.info("查询时间在一月内");
          return;
        }
      }

      if (!date) return;
      this.maxChartLoading = true;

      this.myChartMax.showLoading();

      let curTime = new Date().getTime();
      let stime = null;
      let etime = null;
      if (tag === "range") {
        // 时间周期 date = 天数
        stime = curTime - 1000 * 60 * 60 * 24 * +date;
        this.chartForm.date = null;
      } else {
        this.chartForm.date = date;
        stime = new Date(date[0] + " " + "00:00").getTime();
        etime = new Date(date[1] + " " + "23:59").getTime();

        if (this.chartForm.range != 0) {
          this.chartForm.range = null;
        }
      }

      if (tag == "range") {
        this.labeltimer = {
          stime: this.$moment(stime).format("YYYY-MM-DD "),
          etime: this.$moment(stime).add(date, "days").format("YYYY-MM-DD"),
        };
        this.timeObj = {
          stime: new Date(this.labeltimer.stime).getTime(),
          etime: new Date(this.labeltimer.etime).getTime(),
        };
      } else {
        this.timeObj = {
          stime: stime,
          etime: etime,
        };
      }

      this.getChartDatas(
        this.curMaxChartParams.index,
        this.curMaxChartParams.id,
        this.curMaxChartParams.name,
        this.curMaxChartParams.typeId,
        stime,
        etime,
        -1
      );
    },
    arrChunk(arr, size) {
      //数组切片

      if (!arr || arr.length === 0) {
        return [];
      }
      const tempArr = [];
      const chunkLen = Math.ceil(arr.length / size);
      let last = 0;
      for (let i = 0; i < chunkLen; i++) {
        if (size * i >= arr.length) {
          last = arr.length;
        } else {
          last = size * i + size;
        }
        tempArr.push(arr.slice(size * i, last));
      }
      return tempArr;
    },
    timerFilter(monshowar, data, timerindex = -1) {
      //筛选时间 index 调试
      data = this.$c.deepClone(data);

      let fistarr = data.findIndex((minarr, index) => {
        let fistleng = minarr.length - 1;
        let fiststart = moment(minarr[0].name).format("YYYY-MM-DD HH:mm");
        let fistend = moment(minarr[fistleng].name).format("YYYY-MM-DD HH:mm");
        let isBefore = moment(fiststart).isBefore(monshowar); //数组的第一个时间是不是在预设之前
        let isAfter = moment(fistend).isAfter(monshowar); //数组的最后个时间是不是在预设之前
        let StartIsSame = moment(fiststart).isSame(monshowar); //判断值和数组第一位和最后位是否相等
        let endIsSame = moment(fistend).isSame(monshowar);

        if ((isAfter && isBefore) || StartIsSame || endIsSame) {
          return true;
        }
      });

      if (timerindex == 7) {
      }
      return fistarr;
    },

    chartModalCancel() {
      // this.$store.state.spinShow = true
      // this.getDetails()
      this.$nextTick(() => {
        this.chartForm.date = null; // 清除搜索时间
        this.chartForm.range = null; // 清除搜索时间
        this.curMaxChartParams = {}; // 清除参数
        this.maxVolOptions = {}; // 清除图表值
        this.chartModal = false;
        this.isShold = false;
        this.maxwave = false;
        this.single = false;
        this.$refs["select"].clearSingleSelect();

        //  this.timrcustom=false
        this.$nextTick(() => {
          setTimeout(() => {
            this.timrcustom = false;
          }, 200);
        });
      });
    },
    // 编辑标签
    editSign() {
      this.curTags = this.curDetails.oilSiteLabelList;
      this.tagsModalShow = true;
    },
    modCurTags(tags) {
      this.curTags = tags;
    },
    closetagModal(flag) {
      this.tagsModalShow = flag;
    },
    // // 加载报警记录
    // getWarningLists(page) {
    //   if (page) this.pageInfo.current = page; //分页处理
    //   api.axss("post", , {
    //     ...this.pageInfo,
    //     oilSiteIds: [this.curId],
    //   }).then((res) => {
    //     if (res.code === "00000") {
    //       const datas = res.data;
    //       this.warningLists = datas.records;

    //       // this.warid = datas.records.length > 0 ? datas.records[0].id : ""

    //       if (this.warningLists.length)
    //         this.alarmTime =
    //         this.warningLists[0].alarmStartTime || "";

    //       this.pageInfo.total = datas.total;
    //     }
    //     setTimeout(() => {
    //       this.warningListLoading = false;
    //     }, 500);
    //   });
    // },
    checkYuzhiValMthods() {
      this.yuzhiformData.topTopLine = null;
      this.$refs["topTopLine"].currentValue = null;
      console.log(
        "我触发了",
        this.yuzhiformData.topTopLine,
        this.$refs["topTopLine"].currentValue
      );
      this.$forceUpdate();
    },
    setregulartimer() {
      clearTimeout(this.tttimer);
      this.tttimer = null;
      this.tttimer = setTimeout(() => {
        this.timbo = true;
        clearTimeout(this.tttimer);
      }, this.timernum);
      // this.timernum
    },
    // 阈值配置弹窗
    async yuzhiShow(vol1) {
      let vol = JSON.parse(JSON.stringify(vol1));
      this.forobj = {
        id: this.curId + vol.identifier,
        type: this.soikobj.type,
        chinaType: this.soikobj.typeName,
      };
      if (this.groupAuthorityString !== "r") {
        let data = await relatedInfo({
          id: this.curId + vol.identifier,
          type: this.soikobj.type,
          chinaType: this.soikobj.typeName,
        });

        if (data.code !== "00000") {
          this.$Message.info(data.msg);
          return;
        }
        this.timbo = false;
        this.setregulartimer();
      }

      this.check = {
        toptoplinbo: false,
        toplinebo: false,
        bottomlinebo: false,
        bottombottomlinebo: false,
      };
      this.yuzhiformData = vol;
      this.yuzhiModalLoading = true;
      this.yuzhiModal = true;
      const pdatas = {
        oilSiteId: this.curId,
        oilSiteTypeModelIdentifier: vol.identifier,
        oilSiteTypeModelIdentifierName: vol.name,
      };
      // 获取实验数据
      api.axss("post", "/ocm-oil-site/threshold/getOne", pdatas).then((res) => {
        if (res.code === "00000") {
          const datas = res.data || {};
          this.algformData = datas;
          this.resetNull("algformData");
        }
      });
      const tdatas = {
        oilSiteIdentifier: vol.identifier,
        oilSiteTypeId: this.curDetails.oilSiteTypeId,
        oilType: this.curDetails.oilProductName,
      };
      // 算法
      api
        .axss(
          "post",

          "/ocm-oil-site/oil-site/getThreshold",
          {
            oilSiteId: this.curId,
            oilSiteIdentifier: vol.identifier,
          }
        )
        .then((res) => {
          if (res.code === "00000") {
            const datas = res.data || {};

            this.thresholdData = datas[0] || {
              upUpThreshold: "-",
              upThreshold: "-",
              downThreshold: "-",
              downDownThreshold: "-",
            };

            this.resetNull("thresholdData");
          }
        });

      // 获取阈值配置数据
      api
        .axss(
          "post",
          "/ocm-oil-site/oil-site-threshold/getByOilSiteAndIdentifier",
          pdatas
        )
        .then((res) => {
          if (res.code === "00000") {
            const datas = res.data || {};

            if (datas.id)
              this.yuzhiformData.bjtype =
                datas.alarmType === 1 ? "time" : "min";

            this.yuzhiformData = {
              ...datas,
              ...this.yuzhiformData,
              ...pdatas,
            };
            // let removearr = ['污染度NAS_5_15u', '污染度NAS_15_25u', '游离水', '溶解水AW', '溶解水ppm', '温度', '介电常数']
            // let incldname = vol.name
            // if (removearr.includes(incldname)) {
            //   this.yuzhiformData['dyshow'] = false
            // } else {
            //   this.yuzhiformData['dyshow'] = true
            // }

            let {
              topTopLine,
              topLine,
              bottomLine,
              bottomBottomLine,
              continuousCount1,
              continuousTime1,
            } = this.yuzhiformData;

            if (typeof topTopLine !== "object") {
              this.yuzhiformData.topTopLine = Number(
                +this.yuzhiformData.topTopLine
              );
            }
            if (typeof topLine !== "object") {
              this.yuzhiformData.topLine = Number(+this.yuzhiformData.topLine);
            }
            if (typeof bottomLine !== "object") {
              this.yuzhiformData.bottomLine = Number(
                +this.yuzhiformData.bottomLine
              );
            }
            if (typeof bottomBottomLine !== "object") {
              this.yuzhiformData.bottomBottomLine = Number(
                +this.yuzhiformData.bottomBottomLine
              );
            }
            this.yuzhiformData.continuousCount1 =
              this.yuzhiformData.continuousTimeCount;
            this.yuzhiformData.continuousTime1 =
              this.yuzhiformData.continuousTimeTime;
            this.dataverdatation(this.yuzhiformData);
            this.yuzhiModalLoading = false;
          }
        });
    },
    dataverdatation(data) {
      const {
        alarmType,
        topTopLine,
        topLine,
        bottomLine,
        bottomBottomLine,
        continuousCount,
        continuousTime,
        isTop,
        isBottom,
      } = data;
      if (
        topTopLine == false &&
        topLine == false &&
        bottomLine == false &&
        bottomBottomLine == false &&
        continuousCount == false &&
        continuousTime == false
      ) {
        this.$nextTick(() => {
          this.rest();
        });
      }
      if (isTop == 1) {
        this.check.toplinebo = true;
      } else {
        this.check.toplinebo = false;
      }

      if (isBottom == 1) {
        this.check.bottomlinebo = true;
      } else {
        this.check.bottomlinebo = false;
      }

      if (typeof topTopLine == "number") {
        this.check.toptoplinbo = true;
      } else {
        this.yuzhiformData.topTopLine = null;
      }
      if (typeof topLine == "number") {
      } else {
        this.yuzhiformData.topLine = null;
      }

      if (typeof bottomLine == "number") {
      } else {
        this.yuzhiformData.bottomLine = null;
      }
      if (typeof bottomBottomLine == "number") {
        this.check.bottombottomlinebo = true;
      } else {
        this.yuzhiformData.bottomBottomLine = null;
      }
      // this.yuzhiformData.bjtype = alarmType === 1 ? "time" : "all";
      if (alarmType === 1) {
        this.yuzhiformData.bjtype = "time";
      } else if (alarmType === 2) {
        this.yuzhiformData.bjtype = "all";
      }

      if (
        this.yuzhiformData.isAlgorithmTop == 0 ||
        this.yuzhiformData.isAlgorithmTop == null
      ) {
        this.isAlgorithmname = "手动配置";
        this.isAlgorithm = false;
      } else {
        this.isAlgorithmname = "算法参考";
        this.isAlgorithm = true;
      }
    },
    isAlgoMth(tag) {
      let { topTopLine, bottomBottomLine } = this.yuzhiformData;
      if (!topTopLine) return;
      topTopLine = topTopLine ? Number(topTopLine) : topTopLine;
      bottomBottomLine = bottomBottomLine
        ? Number(bottomBottomLine)
        : bottomBottomLine;

      if (bottomBottomLine > topTopLine) {
        this.$Message.info("告警值低必须小于告警值高");
        this.yuzhiformData.bottomBottomLine = null;
        return;
      }
    },
    checkYuzhiVal(tag) {
      debounce(() => {
        this.inputFormate(tag);
        const { isAlgorithm } = this;

        this.yuzhiValFlag = true;

        let { bottomBottomLine, bottomLine, topLine, topTopLine } =
          this.yuzhiformData;
        bottomBottomLine = bottomBottomLine
          ? Number(bottomBottomLine)
          : bottomBottomLine;
        bottomLine = bottomLine ? Number(bottomLine) : bottomLine;
        topLine = topLine ? Number(topLine) : topLine;
        topTopLine = topTopLine ? Number(topTopLine) : topTopLine;
        //  if(isAlgorithmname)

        if (isAlgorithm) {
          let ctopLine = this.comuupThreshold(this.thresholdData.upThreshold); //
          let cbottomLine = this.comuupThreshold(
            this.thresholdData.downThreshold
          );
          if (ctopLine !== "-" && this.check.toplinebo) {
            topLine = ctopLine;
          }
          if (cbottomLine !== "-" && this.check.bottomlinebo) {
            bottomLine = cbottomLine;
          }
          console.log("topLine,bottomLine", topLine, bottomLine, topTopLine);
          if (topTopLine) {
            if (bottomBottomLine > topTopLine) {
              console.log("tag", tag);
              if (tag == 4) {
                this.$Message.info("告警值高必须大于告警值低");
                this.yuzhiformData.topTopLine = null;
              } else {
                this.$Message.info("告警值低必须小于告警值高");
                this.yuzhiformData.bottomBottomLine = null;
              }

              return;
            }
          }
        }

        let msg = "";
        if (tag == 1) {
          if (bottomLine) {
            if (bottomBottomLine >= bottomLine) {
              this.yuzhiformData.bottomBottomLine = null;

              msg = "告警值(低)必须小于注意值(低)";
              this.yuzhiValFlag = false;
            }
          } else if (topLine) {
            if (bottomBottomLine >= topLine) {
              this.yuzhiformData.bottomBottomLine = null;

              msg = "告警值(低)必须小于注意值(高)";
              this.yuzhiValFlag = false;
            }
          } else if (topTopLine) {
            if (bottomBottomLine >= topTopLine) {
              this.yuzhiformData.bottomBottomLine = null;

              msg = "告警值(低)必须小于告警值(高)";
              this.yuzhiValFlag = false;
            }
          }
        } else if (tag == 2) {
          if (bottomBottomLine) {
            if (bottomLine <= bottomBottomLine) {
              this.yuzhiformData.bottomLine = null;

              msg = "注意值(低)必须大于告警值(低)";
              this.yuzhiValFlag = false;
            }
          }
          if (topLine) {
            if (bottomLine >= topLine) {
              this.yuzhiformData.bottomLine = null;

              msg = "注意值(低)必须小于注意值(高)";
              this.yuzhiValFlag = false;
            }
          }
          if (topTopLine) {
            if (bottomLine >= topTopLine) {
              this.yuzhiformData.bottomLine = null;

              msg = "注意值(低)必须小于告警值(高)";
              this.yuzhiValFlag = false;
            }
          }
        }
        if (tag == 3) {
          if (bottomBottomLine) {
            if (topLine <= bottomBottomLine) {
              this.yuzhiformData.topLine = null;

              msg = "注意值(高)必须大于告警值(低)";
              this.yuzhiValFlag = false;
            }
          }
          if (bottomLine) {
            if (topLine <= bottomLine) {
              this.yuzhiformData.topLine = null;

              msg = "注意值(高)必须大于注意值(低)";
              this.yuzhiValFlag = false;
            }
          }
          if (topTopLine) {
            if (topLine >= topTopLine) {
              this.yuzhiformData.topLine = null;

              msg = "注意值(高)必须小于告警值(高)";
              this.yuzhiValFlag = false;
            }
          }
        }
        if (tag == 4) {
          try {
            console.log("2", topLine);
            if (bottomBottomLine) {
              if (topTopLine <= bottomBottomLine) {
                this.yuzhiformData.topTopLine = null;

                msg = "告警值(高)必须大于告警值(低)";
                this.yuzhiValFlag = false;
              }
            }

            if (bottomLine) {
              const bottomlinebo = this.check.bottomlinebo;
              if (!bottomlinebo) return;
              if (topTopLine <= bottomLine) {
                this.yuzhiformData.topTopLine = null;

                msg = "告警值(高)必须大于注意值(低)";
                this.yuzhiValFlag = false;
              }
            }
            console.log("4", topLine);
            if (topLine) {
              const toplinebo = this.check.toplinebo;
              if (!toplinebo) return;
              if (topLine >= topTopLine) {
                this.yuzhiformData.topTopLine = null;

                msg = "告警值(高)必须大于注意值(高)";
                this.yuzhiValFlag = false;
              }
            }
          } catch (error) {
            console.log("error", error);
          }
        }
        if (msg) {
          this.$Message.info(msg);
        }

        return;
      }, 1000);
    },
    checkOrder(toptopNum, topNum, bottomNum, bottombottomNum) {
      if (
        toptopNum !== undefined &&
        topNum !== undefined &&
        toptopNum <= topNum
      ) {
        
        return {code:"400",msg:"告警值(高)必须大于注意值(高)"} ;
      }
      if (
        topNum !== undefined &&
        bottomNum !== undefined &&
        topNum <= bottomNum
      ) {
    
         return {code:"400",msg:"注意值(高)必须大于注意值(低)"} ;
      }
      if (
        bottomNum !== undefined &&
        bottombottomNum !== undefined &&
        bottomNum <= bottombottomNum
      ) {
        return {code:"400",msg:"注意值(低)必须大于告警值(低)"} ;
      }
      return {code:200};
    },
    submitYuzhi() {
      let yuzhiformDataCopy = deepcopy(this.yuzhiformData);
      const { bottomBottomLine, bottomLine, topLine, topTopLine } =
        this.yuzhiformData;
      const { toptoplinbo, bottombottomlinebo, toplinebo, bottomlinebo } =
        this.check;
      let toptopNum = undefined;
      let topNum = undefined;
      let bottombottomNum = undefined;
      let bottomNum = undefined;

      if (!toptoplinbo && !bottombottomlinebo && !toplinebo && !bottomlinebo) {
        this.$Message.info("请填写报警配置");
        return;
      }
      if (!this.isAlgorithm) {
        if (
          bottomBottomLine != null ||
          bottomLine != null ||
          topLine != null ||
          topTopLine != null
        ) {
        } else {
          this.$Message.info("请填写报警配置");
          return;
        }
      }
      if (toptoplinbo) {
        toptopNum = topTopLine;
      }
      if (toplinebo) {
        if (this.isAlgorithm) {
          let ctopLine = this.comuupThreshold(this.thresholdData.upThreshold); //
          if (ctopLine !== "-") {
            topNum = ctopLine;
          }
        } else {
          topNum = topLine;
        }
      }
      if (bottomlinebo) {
        if (this.isAlgorithm) {
          let cbottomLine = this.comuupThreshold(
            this.thresholdData.downThreshold
          );
          if (cbottomLine !== "-") {
            bottomNum = cbottomLine;
          }
        } else {
          bottomNum = bottomLine;
        }
      }
      if (bottombottomlinebo) {
        bottombottomNum = bottomBottomLine;
      }
      let checobj = this.checkOrder(toptopNum, topNum, bottomNum, bottombottomNum);
      if(checobj.code=="400"){
        this.$Message.info(checobj.msg);
        return;
      }
      if (!this.yuzhiValFlag) return;
      if (
        this.yuzhiformData.continuousCount ||
        // this.yuzhiformData.continuousTime ||
        (yuzhiformDataCopy.continuousCount1 &&
          yuzhiformDataCopy.continuousTime1)
      ) {
        this.yuzhiModalLoading = true;
        yuzhiformDataCopy.alarmType =
          yuzhiformDataCopy.bjtype === "time"
            ? 1
            : yuzhiformDataCopy.bjtype === "min"
            ? 0
            : 2; //"0时间 1次数"
        if (yuzhiformDataCopy.bjtype === "time") {
          yuzhiformDataCopy.continuousTime = null;
          yuzhiformDataCopy.continuousTimeCount = 0;
          yuzhiformDataCopy.continuousTimeTime = 0;
        } else if (yuzhiformDataCopy.bjtype === "min")
          yuzhiformDataCopy.continuousCount = null;
        else {
          // yuzhiformDataCopy.continuousCount = yuzhiformDataCopy.continuousCount1
          // yuzhiformDataCopy.continuousTime = yuzhiformDataCopy.continuousTime1
          yuzhiformDataCopy.continuousTime = null;
          yuzhiformDataCopy.continuousCount = null;
          yuzhiformDataCopy.continuousTimeCount =
            yuzhiformDataCopy.continuousCount1;
          yuzhiformDataCopy.continuousTimeTime =
            yuzhiformDataCopy.continuousTime1;
        }
        this.isAlgorithm
          ? (yuzhiformDataCopy.isAlgorithm = 1)
          : (yuzhiformDataCopy.isAlgorithm = 0);
        api
          .axss(
            "post",
            "/ocm-oil-site/oil-site-threshold/edit",
            yuzhiformDataCopy
          )
          .then((res) => {
            if (res.code === "00000") {
              this.$Message.success("配置成功");
              this.yuzhiModal = false;
              this.yuzhiModalLoading = false;
              this.getDetails(1);
              this.thresholdData = {};
              this.cancelYuzhi();
            }
          });
      } else return this.$Message.info("请填写触发报警配置");
    },
    clearYuzhi() {
      this.$Modal.confirm({
        title: "您确定要删除此监测指标的报警配置吗？",
        onOk: () => {
          this.returnYuzhi(1);
        },
        onCancel: () => {
          this.$Message.info("取消删除");
        },
      });
    },
    rest() {
      this.yuzhiformData.bjtype = null;
      this.check = {
        toptoplinbo: false,
        toplinebo: false,
        bottomlinebo: false,
        bottombottomlinebo: false,
      };
      this.yuzhiformData.topTopLine = null;
      this.yuzhiformData.topLine = null;
      this.yuzhiformData.bottomLine = null;
      this.yuzhiformData.bottomBottomLine = null;
      this.yuzhiformData.continuousCount = null;
      this.yuzhiformData.continuousTime1 = null;
      this.yuzhiformData.continuousCount1 = null;
      //this.yuzhiformData={}
    },
    returnYuzhi(index = 0) {
      let msg;
      index == 0 ? (msg = "重置成功") : (msg = "删除成功");
      this.yuzhiModalLoading = true;
      let yuzhiformDataCopy = deepcopy(this.yuzhiformData);
      yuzhiformDataCopy.continuousCount = 0;
      yuzhiformDataCopy.whetherToRepeat = 1;
      yuzhiformDataCopy.continuousCount = null;
      yuzhiformDataCopy.continuousTimeCount = null;
      yuzhiformDataCopy.continuousTimeTime = null;
      api
        .axss(
          "post",
          "/ocm-oil-site/oil-site-threshold/edit",
          yuzhiformDataCopy
        )
        .then((res) => {
          if (res.code === "00000") {
            this.$Message.success(msg);
            this.yuzhiModal = false;
            this.yuzhiModalLoading = false;
            this.getDetails(1);
            this.cancelYuzhi();
          }
        });
    },
    async cancelYuzhi() {
      if (this.groupAuthorityString !== "r") {
        clearTimeout(this.tttimer);
        this.tttimer = null;
        let { data } = await sockedDel({
          ...this.forobj,
        });
      }
      this.yuzhiModal = false;
      setTimeout(() => {
        this.$nextTick(() => {
          this.reset("yuzhiformData");
          this.rest();
        });
      }, 150);

      this.thresholdData = {};
    },
    changeType(val) {
      if (val == "all") {
        this.yuzhiformData.continuousCount = null;
      } else if (val == "time") {
        this.$nextTick(() => {
          this.yuzhiformData.continuousCount1 = "";
          this.yuzhiformData.continuousTime1 = "";
          this.$forceUpdate();
        });
      }
      this.yuzhiformData.bjtype = val;
    },

    // 报警记录
    recordShow(vol) {
      this.recordModal = true;
      this.recordformData = vol;
      this.dataLists = [];
      this.qthrefrom.oilSiteThresholdId = vol.id;
      this.$nextTick(() => {
        this.getrecolist1(1);
      });
      //debugger

      // let oilSiteThresholdId = this.recordformData.oilSiteThreshold.id || ""
      if (
        (this.userRole.indexOf("m1") > -1 ||
          this.userRole.indexOf("m0") > -1 ||
          this.userRole.indexOf("c1") > -1) &&
        this.recordformData.oilSiteThreshold
      ) {
        api
          .axss("post", "/ocm-oil-site/oil-site-threshold/history/list", {
            oilSiteThresholdId: this.recordformData.oilSiteThreshold.id,
          })
          .then((res) => {
            if (res.code === "00000") {
              const datas = res.data || {};

              this.recordHeight = 240;
              this.dataLists = datas;
            }
          });
      } else if (this.userRole.indexOf("c") > -1) {
        if (this.userRole.indexOf("c1") > -1) {
          this.dataLists = [];
        } else {
          this.recordHeight = 88;
          this.dataLists.push(vol.oilSiteThreshold);
        }
      } else {
        this.dataLists = [];
      }
      this.$nextTick(() => {
        setTimeout(() => {
          var modal = document.getElementsByClassName("recordTable");

          modal[0].scrollTop = 0;
        }, 500);

        //
      });
    },
    // 关联指标弹窗
    releShow(vol) {
      this.points = [];
      this.releLoading = true;
      this.releModal = true;
      this.curReleName = vol.name;
      const datas = {
        oilSiteNameIdentifier: vol.identifier,
        oilSiteId: this.curDetails.id,
        oilSiteName: this.curDetails.oilSiteIotName,
      };
      api
        .axss("post", "/ocm-oil-site/oil-site/lubricationPointindex", datas)
        .then((res) => {
          if (res.code === "00000") {
            setTimeout(() => {
              this.points = res.data;
              this.releLoading = false;
            }, 500);
          }
        });
    },
    resetNull(key) {
      Object.keys(this[key]).forEach((item) => {
        if (this[key][item] === null) this[key][item] = "-";
      });
    },
    reset(key) {
      Object.keys(this[key]).forEach((item) => {
        this[key][item] = "";
      });
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>


<style lang='less' scoped>
.rhdetail {
  h3.title {
    font-size: 18px;
    color: #000;
    margin: 10px 0 20px;
  }

  .detailWrap {
    display: flex;
    padding-bottom: 10px;

    .imgShow {
      flex: 0 0 230px;
      height: 230px;
      overflow: hidden;
      text-align: center;
      // background: #f2f2f2;

      img {
        height: 100%;
        width: 100%;
        object-fit: cover;
      }
    }

    .detail {
      flex: 0 0 70%;
      padding-left: 3%;
      overflow: hidden;

      & > .name {
        position: relative;
        height: 30px;
        display: flex;
        align-items: center;

        .tag {
          font-size: 16px;
          padding-right: 4px;

          // &.success {
          //     color: #19be6b;
          // }

          // &.warning {
          //     color: #ff9900;
          // }

          // &.error {
          //     color: #ed4014;
          // }
        }

        strong {
          font-size: 24px;
        }

        img {
          margin-left: 13px;
          width: 50px;
          height: 22px;
          // position: relative;
          // top: 3px;
        }
      }

      .signs {
        width: 100%;
        margin: 10px 0;

        .tagWith {
          overflow: hidden;
        }

        .sign {
          height: 22px;
          font-size: 12px;
          padding: 0px 8px;
          line-height: 22px;
          margin-right: 6px;
          color: #3163ad;
          background-color: #e6ebf3;
          border-radius: 10px;
          display: inline-table;
        }

        .edit {
          width: 20px;
          vertical-align: bottom;
          margin-left: 5px;
          cursor: pointer;
        }
      }

      .codes {
        display: flex;
        flex-wrap: wrap;
        margin-top: 15px;

        li {
          display: flex;
          flex: 0 0 47%;
          padding: 4px 0;

          &:nth-child(2n-1) {
            margin-right: 6%;
          }

          .tit {
            flex: 0 0 40%;
            color: #aaa;
          }

          .name {
            flex: 0 0 60%;
            text-align: left;
          }
        }
      }
    }
  }

  .zdtip {
    width: 100%;
    font-size: 12px;
    text-align: left;
    background-color: #fae2dc;
    color: #ed4014;
    border-radius: 2px;
    padding: 4px 6px;

    .ivu-icon {
      font-size: 14px;
    }

    time {
      float: right;
      padding-left: 4px;
    }
  }

  .detectionTag {
    margin-top: 20px;

    .detections {
      display: flex;
      flex-wrap: wrap;

      &.detHidden {
        overflow: hidden;
        height: 366px;
      }

      li {
        // flex: 0 0 20.8%;
        // flex: 0 0 24%;
        width: 24%;
        margin-right: 1.3%;
        margin-bottom: 20px;
        border-radius: 4px;
        opacity: 1;
        border: 1px solid #eeeeee;
        padding: 12px 16px;

        &:nth-child(4n) {
          margin-right: 0;
        }

        .nums {
          display: flex;

          .num {
            flex: 0 0 100%;
            position: relative;

            .temp {
              font-size: 16px;

              font-weight: 549;
              color: rgba(0, 0, 0, 0.851);

              .pw {
                font-size: 12px;
                color: #888;
              }

              .iconInfo {
                font-size: 15px;
                color: #bbb;
                cursor: pointer;
              }
            }

            .small {
              position: relative;
              top: 3px;
              left: -4px;
              font-size: 28px;
            }

            .cur {
              position: relative;
              font-size: 12px;
              color: #333;
              padding-top: 4px;
              display: flex;
              justify-content: space-between;
              align-items: self-end;
              position: relative;

              .cur-strong {
                font-size: 38px;
                font-weight: normal;
                line-height: 40px;
              }

              & > strong {
                font-size: 38px;
                font-weight: normal;
                line-height: 40px;
              }

              .btns {
                top: 6px;
                right: 0;
                text-align: right;

                // margin-top: -18px;
                li {
                  margin-bottom: 0 !important;
                }

                .ivu-btn {
                  width: 60px;
                  margin: 6px 0;
                  margin-left: 10px;
                  font-size: 12px;
                  color: #3163ad;
                  border: 1px solid #3163ad !important;

                  &:hover {
                    color: #fff;
                    background-color: #3163ad;
                  }
                }
              }
            }

            .tempNum {
              position: relative;
              margin-bottom: 10px;

              small {
                font-size: 12px;
              }
            }
          }
        }

        .charts {
          position: relative;

          // margin-top: 10px;
          &:hover .iconMax {
            display: block;
          }

          .iconMax {
            display: none;
            position: absolute;
            top: 10px;
            right: 10px;
            z-index: 2;
            width: 30px;
            cursor: pointer;
          }

          .chart {
            width: 100%;
            height: 241px;
          }
        }
      }
    }

    .detTags1 {
      margin-top: -18px;
    }

    .detTags {
      width: 100%;
      text-align: center;
      font-size: 30px;
      color: #aaa;
      // margin-bottom: 12px;
      cursor: pointer;
      position: relative;
      top: 6px;
      line-height: 0;
      padding-bottom: 3px;

      & > .ivu-icon:hover {
        color: #0c479d;
      }
    }
  }

  .records {
    margin-top: 20px;

    .title {
      // display: flex;
      // justify-content: space-between;
      .history {
        display: inline-block;
        font-size: 13px;
        color: #999;
        padding-left: 10px;
      }
    }
  }

  .history {
    display: flex;
    margin-top: 2px;
    color: #999;
    font-size: 12px;
    text-align: left;

    span:last-child {
      margin-left: auto;
    }
  }
}
</style>
<style lang="less">
.chartMaxModal {
  .charts {
    position: relative;
  }

  .ivu-modal-wrap {
    left: 0 !important;

    .ivu-modal-body {
      padding: 0;
    }

    .ivu-modal-fullscreen {
      top: 0 !important;
    }

    .ivu-modal {
      top: 0 !important;
    }
  }

  .chartMaxSearch {
    text-align: center;
    padding: 26px 24px 5px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .ivu-select {
      text-align: left;
    }

    .center-margin {
      margin-right: 32px;
    }
  }

  .chartMax {
    width: 100%;
    height: 100%;
    margin: 0 auto;
  }
}

.yuzhiModal {
  .yuzhi {
    .desc {
      color: #999;
      padding: 4px 0 10px;
    }

    .yuzhi-label {
      font-size: 14px;

      font-weight: 400;
      color: rgba(0, 0, 0, 0.851);
      margin-bottom: 4px;
    }

    .yuzhi-line-drawer {
      width: 100%;
      height: 1px;
      border-bottom: 1px solid #f2f2f2;
      margin: 10px 0;
    }

    .yuzhi-title-drawer {
      margin-top: 20px;
      font-size: 15px;
      color: #333;
    }

    .yuzhi-cank-drawer {
      font-size: 15px;
      margin-bottom: 10px;

      .trawerfont {
        text-align: left;
        position: relative;
      }

      span {
        font-size: 14px;

        font-weight: 400;
        color: #0070cc;
        cursor: pointer;
      }

      .ivu-col {
        &:nth-child(2),
        &:nth-child(3) {
          text-align: left;
        }

        .ivu-icon {
          font-size: 16px;
          color: #0c479d;
          cursor: pointer;
        }
      }
    }

    .drwaer-flex {
      display: flex;
      align-items: center;
    }

    .yuzhi-limit-drwaer {
      .ivu-col {
        margin-bottom: 10px;

        .ivu-form-item {
          margin-bottom: 0;

          .ivu-form-item-label {
            width: 80px !important;
          }

          .ivu-form-item-content {
            margin-left: 80px !important;

            .ivu-input-wrapper {
              width: 90px;
            }
          }
        }

        &:nth-child(2),
        &:nth-child(3) {
          text-align: left;
          line-height: 34px;
        }
      }
    }

    .yuzhi-warning-drawer {
      // padding-bottom: 30px;
      .ivu-radio-group {
        .ivu-radio-wrapper {
          display: block;
          margin-bottom: 10px;

          .ivu-input-wrapper {
            width: 90px;
          }
        }
      }
    }
  }
}

.releModal {
  .rele {
    position: relative;
    max-height: 260px;
    overflow-y: auto;

    &::-webkit-scrollbar {
      display: none;
    }
  }
}

.recordModal {
  .record {
    position: relative;

    // max-height: 260px;
    &::-webkit-scrollbar {
      display: none;
    }

    .ivu-table-wrapper {
      overflow-y: auto;
    }

    .desc {
      color: #999;
      padding: 4px 0 0px;
    }
  }
}

.icon-img {
  width: 16px;
  height: 16px;
  /* margin-top: 3px; */
  position: relative;
  top: 3.5px;
}

.rhname {
  width: 69px;
  height: 22px;
  text-align: center;
  line-height: 22px;
  color: #5e5e5e;
  background: #f7f7f7;
  padding: 0 3px;
  border-radius: 60px;
  cursor: pointer !important;
}

.whi-per {
  white-space: nowrap;
}

.sugsst {
  background: #fff;
  margin: 20px 0;
  padding: 16px 18px;
  border: 1px solid #dcdee2;
  border-color: #e8eaec;
  border-radius: 4px;
}

.fault-analysis {
  background: #fff;
  margin: 20px 0;
  padding: 16px 18px;
  border: 1px solid #dcdee2;
  border-color: #e8eaec;
  border-radius: 4px;
}

.select-label {
  display: flex;
  align-items: center;
}

.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
}

.pipe-select-cate {
  .ivu-select-item-focus:hover {
    // background: #f3f3f3;
  }

  .ivu-select-item-focus {
    background: #fff;
  }

  .ivu-select-item-selected {
    background: #f3f3f3;
  }
}

.charmaxTitle {
  display: flex;
  align-items: center;

  .title-left {
    font-size: 16px;

    color: rgba(0, 0, 0, 0.851);
  }

  .red-lable {
    font-size: 12px;

    font-weight: 400;
    color: rgba(245, 34, 45, 0.651);
    margin-left: 8px;
  }
}

.radio-ur {
  cursor: pointer;
}

.mf12 {
  margin-left: 0px;
}

.waring-index {
  width: 100%;
  height: 34px;
  background: #fff7da;
  display: flex;
  align-content: center;
  padding: 9px 16px;
  margin: 20px 0;
  font-size: 12px;
  align-items: center;
  font-weight: 400;
  color: rgba(84, 84, 84, 1);

  span {
    color: rgba(12, 71, 157, 1);
  }
}

.img-border {
  width: 28px;
  height: 28px;
  background: #eceef2;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
}

.tz-line {
  display: flex;
  align-items: center;
  width: 225px;
  height: 24px;
  font-size: 12px;
  font-weight: 400;
  color: #262626;

  z-index: 0;
  border: 4px;

  .text {
    position: relative;
    background: rgba(236, 238, 242, 0.35);
    height: 24px;
    line-height: 24px;
    left: -7px;
    padding: 0 14px;
    max-width: 240px;
  }
}
.blurback {
  filter: blur(4px);
}
</style>